export default {
  pledgeLoanPendingReview: "審査待ち",
  pledgeLoanOverdue: "延滞",
  pledgeLoanName: "担保付ローン",
  pledgeLoanInterest: "利息",
  pledgeLoanMaturityDate: "到期日",
  pledgeLoanHeroTitle: "デジタル資産を最大限活用し、より高い収益を獲得しましょう！",
  pledgeLoanCurrency: "通貨",
  pledgeLoanApplicationDate: "申込日",
  pledgeLoanCollateralTerm: "担保期間",
  pledgeLoanHeroSubtitle: "プロモーション期間中、担保利息は 0 です。",
  pledgeLoanRejected: "拒否済み",
  pledgeLoanBorrowAmount: "借入金額",
  pledgeLoanReviewDate: "審査日",
  pledgeLoanWithdrawalWarning: "未決済の担保付ローン注文があります。出金申請の前に決済を完了してください。",
  pledgeLoanRepayment: "返済",
  pledgeLoanUnpayAmount: "未返済額",
  pledgeLoanRepayTime: "決済時間",
  pledgeLoanCollateralAmount: "担保金額",
  pledgeLoanCollateralRatio: "担保比率",
  pledgeLoanInProgress: "処理中",
  pledgeLoanSettled: "決済済み",
  pledgeLoanApplyNow: "今すぐ申し込む",
  pledgeLoanFinishedText: "これ以上データはありません",
  pledgeLoanPreviewOnly: "プレビューのみです。申請は送信されていません。",
  required: '必須',
  home: '始める',
  market: 'マーケット',
  currency: '交換',
  walletTrade: 'スポット',
  contract: '契約する',
  wallet: '資産',
  pulling: 'プルダウンして更新...',
  loosing: 'リリースして更新...',
  loading: '読み込んでいます...',
  loadingError: '読み込みに失敗しました',
  nothing: 'データなし',
  finished: '',
  price: '価格',
  number: '量',
  recharge: 'デポジット',
  transfer: '移行',
  invite: '招待',
  inviteDes: '友達を招待して参加してください',
  contact: 'お問い合わせ',
  contactDes: '7*24 オンライン',
  fastTrade: 'オプション',
  name: '名前',
  fastPrice: '価格',
  trend: '24H %',
  all: '全て',
  growthList: '値上がり者',
  loserList: '敗者',
  vol: '24H Vol',
  buy: '買う',
  sell: '売る',
  optimal: '市場価格',
  marketOrder: '市場取引',
  limitOrder: 'リミットトレード',
  useable: '利用可能',
  tradeVol: '額',
  entrust: '指値注文',
  entrustTotal: '額',
  noLogin: 'ログアウト',
  toLogin: 'ここでログイン',
  cancelOrder: 'キャンセル',
  cancelError: 'キャンセルできませんでした',
  cancelSuccess: 'キャンセルしました',
  cancelTip: 'キャンセルしますか？',
  completed: '完了',
  canceled: 'キャンセル',
  marketPrice: '市場',
  limitPrice: 'リミット',
  entrustPrice: '価格',
  entrustNum: '量',
  currencyType: 'シンボル',
  headerCurrencyType: 'シンボル',
  currencyOrder: '取引実績',
  history: '歴史',
  tryAgain: '再試行',
  entrustPriceTip: '投入価格',
  tradeNumTip: '投入量',
  tradeNumLess: '数量は 0 より大きくする必要があります',
  numLessTip: '残高不足です',
  tradePriceTip: '投入量',
  balanceTip: '残高不足です',
  tradeError: '取引に失敗しました',
  tradeSuccess: '取引成功',
  tip: '知らせ',
  tradeConfirm: '取引を確定しますか？',
  cancelText: 'キャンセル',
  confirmText: '確認',
  toBuy: '買い占めます',
  toSell: '空売り',
  confirmToBuy: '買い占めます',
  confirmToSell: '空売り',
  slPrice: 'SL 価格',
  sl: 'SL',
  tp: 'TP',
  tpPrice: 'TP 価格',
  currentOrder: '現在の注文',
  historyOrder: '歴史',
  setting: '設定',
  unwind: '近い',
  handUnwind: '手動で閉じる',
  futuresPay: '',
  forceUnwind: '清算',
  slTp: 'SL/TP',
  fastTradeUnwind: 'オプション',
  blowUp: '清算',
  openNum: '量',
  warrant: 'マージン',
  openPrice: '価格',
  fee: '費用',
  profit: '利益',
  lastPrice: '現在の価格',
  unwindPrice: '終値',
  unwindError: '閉じることができませんでした',
  unwindSuccess: '正常に閉じます',
  setSuccess: '正常に設定されました',
  setError: '設定に失敗しました',
  setSlTp: '設定 SL/TP',
  second: 's',
  multiple: '多数',
  direction: 'タイプ',
  tradeCurrency: 'シンボル',
  loss: '損失',
  fill: '勝つ',
  executePrice: '価格',
  currentPrice: '現在の価格',
  closePrice: '終値',
  secondNum: '限目',
  contractOrder: '先物注文',
  fastTradeOrder: 'オプション注文',
  overview: '概要',
  ieoBuy: '先行販売',
  balanceTotal: '総資産',
  withdraw: '撤回する',
  tradeOrder: 'トレードオーダー',
  rechargeHistory: '預金記録',
  withdrawHistory: '出金記録',
  freeze: 'フローズン',
  amountTo: '',
  tipText: '知らせ',
  ieoTip: 'もうすぐです。',
  financeList: '財務記録',
  currencyAccount: '資金口座',
  contractAccount: '先物口座',
  time: '時間',
  status: 'スターテス',
  balanceTyle: 'アカウント',
  pay: '結果',
  income: '所得',
  lastBalance: '残高',
  orderNo: 'ID',
  money: '額',
  date: '日にち',
  finallyIncome: '受け取り金額',
  commitMoney: '額',
  orderNum: 'ID',
  waitReview: '確認予定',
  reviewPass: '合格した',
  reviewReject: '却下',
  waitWallet: 'レビュー中',
  walletPass: '合格した',
  walletReject: '却下',
  withdrawSuccess: '出金成功',
  withdrawError: '転送に失敗しました',
  high24H: '24H 高い',
  low24H: '24H 低い',
  num24H: '24H Vol',
  minute: '分',
  hour: '時間',
  day: '日',
  week: '週',
  markets: '市場',
  open: '開ける',
  close: '近い',
  high: '高い',
  low: '低い',
  volume: 'Vol',
  fastLogin: 'ここでログイン',
  register: '登録',
  auth: '確認',
  authSuccess: '検証済み',
  noPass: '却下',
  authCommit: 'レビュー中',
  onAuth: '未確認',
  onLogin: 'ログアウト',
  securitySet: '安全',
  userAgree: 'ユーザーサポート',
  aboutUs: '私たちに関しては',
  logout: 'ログアウト',
  logoutSuccess: 'ログアウト成功',
  lookAuthInfo: '私の情報を確認する',
  authAgain: '再確認',
  authInfo: '情報',
  account: 'アカウント',
  countryArea: '国/地域',
  idNo: 'ID#',
  idNoTip: 'ID番号入力',
  email: '郵便',
  emailInput: 'メールアドレスを入力',
  setLoginPwd: 'ログインパスワードの設定',
  loginPwdInput: 'ログインパスワードを入力（8～20文字）',
  loginPwdTip: 'ログインパスワードを入力',
  loginPwdLen: 'ログインパスワードは 8 ～ 20 文字にする必要があります',
  setFinancePwd: 'ファンドのパスワードを設定する',
  financePwdInput: 'ファンドパスワードを入力（6～20文字）',
  financePwdTip: '資金パスワードを入力',
  financePwdLen: 'ファンドのパスワードは 6 ～ 20 文字にする必要があります',
  inviteCode: '招待コード',
  inviteCodeTip: '招待コードを入力',
  inviteInput: '招待コードが必要です',
  imageCode: 'Captcha',
  imageCodeInput: '入力キャプチャ',
  registerTip: '登録は同意することを意味します ',
  agree: '《ユーザー規約》',
  agreeText: 'ユーザー規約',
  next: '次',
  registerSuccess: '完全に登録する',
  registerError: '登録に失敗しました',
 securityCheck: '安全',
googleAuthenticator: `Google 認証システム`,
googleAuthBoundTitle: `このアカウントでは Google 認証システムが有効です。`,
googleAuthBoundDesc: `Google 認証システムがアカウントをさらに保護しています。`,
googleAuthEnableTitle: `Google 認証システムを有効にする`,
googleAuthEnableDesc: `アカウントにセキュリティレイヤーを追加します。`,
googleAuthScanTip: `Google 認証システムで QR コードをスキャンし、6 桁のコードを入力してください。`,
googleAuthConfirm: `連携を確認`,
googleAuthCodeTitle: `Google 認証`,
googleAuthCodeDesc: `Google 認証システムの 6 桁のコードを入力してください。`,
googleAuthCodeInput: `Google 認証コードを入力`,
googleAuthBindSuccess: `Google 認証システムを有効にしました`,
googleAuthLoadError: `Google 認証システムの読み込みに失敗しました`,
  checkCodeInput: '確認コードを入力',
  sendCheckCode: '送信',
  sendSuccess: '送信済',
  sendError: '送信できませんでした',
  welcome: 'へようこそ',
  loginEmail: '郵便',
  loginEmailInput: 'メールアドレスを入力',
  loginPwd: 'ログインパスワード',
  login: 'ログイン',
  forgetPwd: 'パスワードをお忘れですか',
  loginTip: 'ログインは同意したことを意味します',
  loginSuccess: '完全にログイン',
  loginError: 'ログインに失敗しました',
  fullname: '名前',
  fullnameTip: 'あなたの名前を入力してください',
  country: '国/地域',
  countryTip: '国・地域を入力',
  imgFront: '身分証明書の正面の写真をアップロードしてください',
  imgReverse: '身分証明書の裏面の写真をアップロードしてください',
  commit: '送信',
  commitSuccess: '完全に送信',
  commitError: '送信できませんでした',
  selectCurrency: '暗号を選択',
  rechargeNet: '通信網',
  rechargeAddress: '入金先',
  copyAddress: 'アドレスをコピー',
  minRecharge: '最低入金額',
  copySuccess: '完全にコピー',
  copyError: 'コピーできませんでした',
  withdrawTip: 'アカウント認証後、出金可能',
  withdrawAddress: '出金先住所',
  withdrawAddressInput: '出金アドレス入力',
  withdrawNet: '通信網',
  withdrawNum: '額',
  withdrawNumInput: '投入量',
  withdrawNumLess: '残高不足です',
  withdrawMin: '最低出金額',
  balanceUse: '利用可能',
  actualMoney: '受け取り金額',
  actualMoneyText: '受け取り金額',
  financePwd: 'ファンドのパスワード',
  trade: '',
  withdrawFail: '出金できませんでした',
  commitTime: '日にち',
  from: 'から',
  to: 'に',
  transferMoney: '投入量',
  transferSuccess: '完全転送',
  transferError: '転送に失敗しました',
  transferHistory: '譲渡記録',
  updateFinancePwd: 'ファンドのパスワードを変更する',
  confirmPwd: 'パスワードを認証する',
  confirmPwdInput: '確認パスワードを入力',
  updatePwd: 'パスワードを変更する',
  updatePwdSuccess: '完全に変更',
  updatePwdError: '変更できませんでした',
  noAlike: 'パスワードが一致しません',
  emailUpdate: 'メールアドレスを変更する',
  loginPwdUpdate: 'ログインパスワードの変更',
  financePwdUpdate: 'ファンドのパスワードを変更する',
  newEmail: '新しいメールアドレス',
  emailUpdateTip: '新しいメールアドレスを入力',
  checkEmail: 'メールアドレスの確認',
  updateEmail: 'メールアドレスを変更する',
  updateEmailError: '変更できませんでした',
  updateEmailSuccess: '完全に変更',
  checkError: '確認できませんでした',
  pwdLen: '8～20文字',
  inviteUrl: '紹介リンク',
  myInviteCode: '招待コード',
  fastInvite: '今すぐ招待',
  myInvite: '招待リスト',
  registerTime: '日にち',
  bulletin: '発表',
  inviteFriend: '友達を招待',
  saveAccount: 'アカウントとパスワードを保存する',
  indicator: '指標',
  type: 'の種類',
  amount: '額',
  scanError: '画像認識に失敗しました',
  scanInitErr: '初期化に失敗しました',
  noCamera: 'カメラの許可なし',
  secondTip: '金額は {tip} 以上である必要があります',
  completePrice: '価格',
  profitText: '利益',
  profitAndLoss: '推定損益',
  timeUp: 'タイムアップ',
  balanceText: '歴史',
  closeAll: 'すべて閉じる',
  assetRate: '証拠金率',
  cancel: 'キャンセル',
  cancelInfo: 'キャンセルを確認しますか？',
  buyCurrency: 'シンボル',
  closeCurrency: '通貨',
  buyPrice: '価格',
  valuation: '評価',
  profitP: '収率',
  buySuccess: '無事',
  swiperTitle1: '世界トップのデジタル暗号交換',
  swiperSub1: '100,000 人以上のユーザーから信頼されています',
  ieoBuying: '進行中',
  ieoOpen: '開始日 (UTC-5)',
  ieoClose: '終了日(UTC-5)',
  about: 'だいたい',
  ieoPlan: '分布',
  ieoInfo: '情報',
  ieoContact: 'ソーシャルメディア',
  ieoStart: '初期化',
  ieoBuyStart: 'IEO 始める',
  ieoBuyEnd: 'IEO 終了',
  ieoIsTrade: '発売',
  introduce: '序章',
  ieoSubBuy: 'IEO',
  subBuyHistory: 'IEO 歴史',
  rechargeTip1: '1. これはあなたの最新の一意のアドレスです。プラットフォームが資金を別のアカウントに転送したり、確認コードを要求したりすることは決してありません。',
  rechargeTip2: '2. デポジットには、確認のために少なくとも 10 個のネットワーク ブロックが必要です。 確認後、アカウントは自動的に資金を受け取ります。',
  withdrawTip1: '1. 入金側と同じネットワークをこの出金用に選択していることを確認し、受信プラットフォームがネットワークをサポートしていることを確認してください。 そうしないと、資産を失います。',
  withdrawTip2: '2. プラットフォームが申請を承認した後、ネットワークブロックはあなたの撤回を確認します.',
  withdrawTip3: '3. 引き出しには、確認のために少なくとも 10 個のネットワーク ブロックが必要です。 確認後、アカウントは自動的に資金を受け取ります。',
  retrievePwd: 'パスワードを再設定する',
  order: '私の注文', 
  registerTitle: 'サインアップ アカウント', 
  emailCheck: 'メール認証コード', 
  haveAccount: 'すでにアカウントをお持ちですか？',  
  userInfo: '個人情報', 
  userAuth: 'アカウントの確認', 
  footerTip: '最終的な解釈権はプラットフォームに属します', 
  marketInfo: 'マーケット', 
  viewMore: 'クリックして詳細を確認', 
  tradeText: 'トレード', 
  position: 'ハンディキャップ', 
  level: 'レベル', 
  oneBuy: '買う', 
  oneSell: '売る', 
  newTrade: 'リアルタイム',
  tradePair: 'シンボル', 
  historyEntrust: '注文履歴', 
  allOrder: '全記録', 
  total: '合計', 
  oneOrder: '注文', 
  priceTip: '投入価格', 
  numberTip: '投入量', 
  foundInput: '投入量', 
  foundTip: '金額を入力してください', 
  countdown: '秒読み', 
  tradeMoney: '額', 
  walletOverview: '資産の概要', 
  ieoBuyAccount: 'プレセールアカウント', 
  selectRechargeAddress: '入金アドレスを選択', 
  successText: '成功', 
  errorText: '失敗', 
  selectWithdrawAddress: '出金アドレス入力', 
  withdrawSuText: '送信成功', 
  transferMoneyLabel: '額', 
  paramsError: 'パラメータエラー', 
  reset: 'リセット', 
  selectText: '探す', 
  emailManage: 'アカウント管理', 
  loginPwdDes: 'ログインパスワードを変更する', 
  updateText: '変更', 
  financePwdDes: 'ファンドのパスワードを変更する', 
  emailManageDes: 'アカウントのセキュリティを維持する', 
  oldEmail: '元のメールアドレス', 
  countryAreaTip: '国または地域を入力',  
  agreeTip: '「利用規約」をご確認ください',
  volume24h: '24H Vol',
  // 首页
  currencyHomeType: 'シンボル',
  whyUs: 'なんで私達なの？',
  why1: '保証と保険',
  why1Des: '暗号通貨の 80% を安全なコールド ウォレットに保管しています。 コールド ストレージは、Ledger によって保護および保険がかけられています。',
  why2: '迅速な取引',
  why2Des: '何百万ものトランザクションを処理できます。 当社のシステム インフラストラクチャは、急増する需要に合わせて数秒でスケールアップできます。',
  why3: 'シンプルで使いやすい',
  why3Des: '当社のプラットフォームでの取引は超高速です。 私たちは何百万人もの人々が使用するテクノロジーを構築してきました。その経験が、この強力な取引所の構築に役立っています。',
  why4: 'インスタント取引',
  why4Des: 'ワンクリックで 150 以上の仮想通貨を即座に取引できます。',
  why5: 'ベストプライス',
  why5Des: '流動性の高いすべての暗号通貨を取引します。',
  why6: '信頼',
  why6Des: '80 万人以上のユーザーが信仰を持ち、数百万ルピーを取引しています。',
  homeGift: '登録ボーナスと引き換えに $30 を無料でゲット。',
  popular1: '$100,000 米ドル+',
  popular1Des: '総取引量',
  popular2: '150+',
  popular2Des: '対応通貨',
  popular3: '800K+',
  popular3Des: '認証済みユーザー',
  globalText: '暗号通貨取引で 80 万人以上のグローバル ユーザーから信頼されています',
  startText: 'わずか 5 分で始められます。',
  start1: 'サインアップ',
  start1Des: 'ウェブサイトを開くか、アプリをダウンロードして、メールで登録します。',
  start2: 'KYC',
  start2Des: '身分証明書を手元に用意し、基本的な KYC の詳細を入力して、アカウントを確認してください。',
  start3: 'デポジット',
  start3Des: 'デジタル ウォレットに簡単に入金できます。',
  start4: '買う/売る',
  start4Des: '最高の価格で暗号通貨を売買および取引します。',
  appTitle: 'アプリが利用可能になりました',
  createTeam: '積立金',
  angelFund: 'エンジェルファンド',
  ecology: '制度と生態系',
  presale: '先行発売',
  mechanism: 'マイニングの仕組み',
  trading: '為替取引',

  issuePrice: '発行価格',
  minBuyPrice: '最小サブスクリプション',
  buyNum: '1 日あたりのサブスクリプション',
  buyTotal: '1 日の合計サブスクリプション',
  Increment: 'サブスクリプションの増分',
  blockchain: 'ブロックチェーン',

  sellTotal: '発行総額',
  currentBuy: '現在のサブスクリプション',
  dowload: 'ダウンロードセンター',
  lessMinTip: '最小金額未満にすることはできません。',
  appDes: 'クラス最高の規制された暗号通貨交換プラットフォームのセキュリティ、取引、および機能を、スマートフォンで直接入手してください。',
  footerBottomTip: 'このウェブサイトで提供される情報は、投資、財務、取引またはその他の事柄に関係するアドバイスと見なされず、サイト上のコンテンツがそうした目的で扱われることはないものとします。仮想通貨への投資は、本質的に不安定かつ高いリスクを伴います。失うと困窮するような額を投資しないようにしてください。',

  stakeAccount: 'ステーキングアカウント',
  serviceAccount: 'サービス アカウント',
  lock: 'ロック',
  lockPrice: 'ロックされた価格',
  ieoHistory: 'IEOの歴史',
  lockHistory: 'ロック履歴',
  sellHistory: '売却履歴',
  stake: 'ステーキング',
  service: 'サービス',
  ieoBuyTip: '*IEO 注意: GPTH の数には制限があります。 ユーザーのIEO申請を審査し、3時間ごとにランダムに抽選を行います。 比較的多額の金額を持っているユーザーは GPTH を購入する可能性が高くなります。 各ユーザーは 1 日に 3 回まで購入できます。',
  ieoLockTip: '*価格のロック: GPTH の価格をロックするには、USDT を担保通貨として使用する必要があり、担保率は GPTH の価値の 30% です。 GPTH のローンチ後、ユーザーはその時点でロックされた価格で GPTH を販売できます。',
  ieoSellTip: '*IEO 販売: GPTH の販売には、サービス手数料として GPTH 価格の 10% が必要です。 GPTHの売却後、交換したUSDTは20日で凍結解除され、差し入れたUSDTは20日で凍結解除されます。',
  whitePaper: '白書',
  cost: '料金',
  currentEstimate: '現在の評価',
  stakeNum: 'ステーキング量',
  estimate: '評価',
  consume: '消費',
 
  seedSell: 'シードラウンド',
  privateSell: 'プライベートラウンド',
  openSell: 'KOLラウンド',
  ieoAward: 'パブリックラウンド',
  ieoGrowUp: 'チーム',
  partner: 'アドバイザー',
  consultant: 'マーケティング',
  ieoName: '流動性',
  conAward: '稼ぐAI',
  staking: 'ステーキング',

  release: 'リリース',
  closedTime: '閉店時間',
  remark: '述べる',

  totalProfit: '利益総額',
  transferIn: '転入',
  transferOut: '転出',
  equity: '純資産',


  emailaddress: '電子メールアドレス',
  
  homeremind1: '人気の暗号通貨',
  homeremind2: 'さらに多くの市場を見る',
  homeremind3: '最終価格(USD)',
  homeremind4: '24時間変更可能',
  homeremind5: 'アクション',
  homeremind6: 'もっと見る',
  homeremind7: "ユーザーのトップの選択",
  homeremind8: '24時間取引高',
  homeremind9: 'プライム仮想資産',
  homeremind10: '当社の主力製品',
  homeremind11: '幅広い取引ツールから選択可能',
  homeremind12: 'スポット',
  homeremind13: '700以上の暗号通貨を取引可能',
  homeremind14: '先物取引で体験をアップグレード',
  homeremind15: 'FTZINC Earn',
  homeremind16: '業界最高の APY',
  homeremind17: '当社の多様なサービス',
  homeremind18: '多彩なサービスで無限の可能性を探る',
  homeremind19: 'IEO サブスクリプション',
  homeremind20: "最高のプレセール暗号通貨",
  homeremind21: 'VIPカスタマーサービス',
  homeremind22: '7*24時間',
  homeremind23: 'コミュニティ',
  homeremind24: 'ここで私たちと一緒に富のチャンスを見つけてください',
  homeremind25: '外出先でも取引できます。 いつでもどこでも。',
  homeremind26: 'アプリとデスクトップ クライアントで最新情報を入手してください。',
  homeremind27: 'ソーシャルメディアでフォローしてください',
  homeremind28: '最新ニュースを入手してください',
  homeremind29: 'いつでもどこでも取引',
  homeremind30: 'iOS、Android、または API で FTZINC を試してください。',

  ieoDes: `デジタル資産スマートアプリケーションチェーン（DAS）は、ブロックチェーン技術を基盤とするデジタル資産スマートアプリケーションエコシステムを構築し、従来の資産流通の障壁を打ち破ることを目指しています。`,
  ieoDes1: `個人資産を細分化することで、ユーザーに多様なオンチェーン資産運用サービスを提供し、効率的な資産ファイナンス、付加価値、質入れ、貸出を可能にします。これにより、ユーザーは安定的かつ大きな収益を得ることができ、デジタル資産分野におけるイノベーション、開発、そしてコンプライアンス遵守のアプリケーションを促進します。`,


  
  ieoDes10: `エネルギー生態系備蓄スマートチェーン（ERS）は、ブロックチェーン技術とグローバルなエネルギー生態系備蓄ニーズを統合する革新的なブロックチェーンプロジェクトです。その中核的な目的は、世界的なエネルギー不足や予期せぬ事態発生時におけるエネルギー供給の安全保障という課題を解決することです。`,
  ieoDes11: `本プロジェクトは、複数の国の業界リーダーで構成されるコアチームによって、分散型エネルギー生態系備蓄スマートプラットフォームを構築します。このプラットフォームは、研究開発、応用、セキュリティ、輸送など、エネルギー産業チェーン全体を接続します。トークンエコノミーシステムを通じて、エコシステムの共同構築を促進し、エネルギー資源のインテリジェントな配分、生態系的な貯蔵、そしてグローバルな循環を実現します。`,
  ieoDes12: `本プロジェクトは、エコシステム唯一のトークンとしてERSトークンを発行します。科学的なトークン配分と明確な上場ロードマップを通じて、プロジェクトの実施とエコシステムの発展を促進し、グローバルなエネルギー安全保障のためのブロックチェーン技術ソリューションを提供します。`,



  foundingTeam: '創設チーム',
  managementTeam: '経営陣',
  investors: '投資家',
  ecologicalFund: '生態基金',
  presaleNew: '先行販売',
  stakingNew: 'ステーキング',
  publicTrading: '公開取引',

  aboutName: 'FTZINCについて',
  aboutContent: `<p><strong>FTZINCの現在</strong></p><p><span style="font-family: 宋体;">FTZINCは現在、米国、英国、オーストラリア、キプロス、ジブラルタル、ポーランド、ブルガリア、セーシェルにオフィスを構えるグローバル企業です。わずか短期間で、ヨーロッパで最も急成長している投資取引プラットフォームの一つとなり、前年比3桁の成長を記録し、グローバルチームはわずか2年で5倍に成長しました。</span></p><p><span style="font-family: 宋体;">しかし、私たちの根底にあるのは、人を中心としたビジネスです。テクノロジーとイノベーションを基盤に、人々が潜在能力を最大限に発揮できるプラットフォームを構築してきました。</span></p><p><span style="font-family: 宋体;">新しいスキルを習得したい、資産を増やしたい、企業の行動に責任を負わせたいなど、お客様の動機が何であれ、私たちはお客様の取引と投資の目標達成を支援することに尽力しています。</span></p><p><span style="font-family: 宋体;">英国金融行動監視機構、キプロス証券取引委員会、オーストラリア証券投資委員会、セーシェル金融サービス機構、バハマ証券委員会の認可</span>・<span style="font-family: 宋体;">規制を受け、数々の賞を受賞したグローバル投資取引プラットフォームにご信頼ください。</span></p><p><span style="font-family: 宋体;">24時間365日対応の卓越したカスタマーサービスと、手数料ゼロ、隠れた手数料なし、低額のオーバーナイト手数料、そして競争力のあるスプレッドによる透明性の高い価格設定をお約束します。</span></p><p> </p><p><strong>私たちのビジョン</strong></p><p><span style="font-family: 宋体;">何十年もの間、金融サービスは富裕層によって、富裕層のために運営されてきました。FTZINCの創設者たちは、この状況を変えたいと考えました。私たちの使命は、従来の金融システムを破壊し、取引をより身近なものにすることでした。</span></p><p><span style="font-family: 宋体;">私たちは、人々に金融市場へのアクセスを提供することを目指しました。このシンプルなアイデアから、革命が生まれました。それは、一般の人々が主導権を握り、自分たちの生活、経済的な将来、そして何よりも世界の未来に変化をもたらす革命です。</span></p><p><span style="font-family: 宋体;">個人投資家がテスラを支援し、世界で最も価値のある企業の一つを築き上げようと結集し始めた時、彼らは革新的な技術を持つ成長株に投資しただけでなく、より良い未来、より持続可能な未来への期待に投資していたのです。環境活動家や政治家もそれぞれの役割を果たしましたが、テスラの株価は、化石燃料に依存した自動車業界全体が電気自動車へと移行する中で、決定的な役割を果たしました。</span></p><p><span style="font-family: 宋体;">そして、FTZINCは、個人投資家の革命を常に支え、推進してきました。2016年の設立以来、私たちはテクノロジーの力を活用し、旧来の参入障壁を根絶することで、取引と投資の選択肢を広げてきました。</span></p><p><span style="font-family: 宋体;">現在、私たちのグローバルなウェブおよびアプリベースのプラットフォームは、400万人以上のトレーダーが、人生、経済的な未来、そして世界に変化をもたらそうとする道のりを支えています。</span></p>`,


  detailName0: 'デポジット',
  detailName1: '撤退',
  detailName2: 'フリーズ',
  detailName3: '解凍',
  detailName4: 'スポット市場取引',
  detailName5: 'スポットリミットトレード',
  detailName6: '契約市場取引',
  detailName7: '契約限度額取引',
  detailName8: '契約は完了しました',
  detailName9: 'IEO',
  detailName10: 'デポジット',
  detailName11: '凍結引き出し',
  detailName12: '減少-撤退',
  detailName13: '返金・出金が拒否されました',
  detailName14: 'トランスファー',
  detailName15: '契約が成立しました',
  detailName16: '清算',
  detailName17: '返金・出金がキャンセルされました',
  detailName19: '担保付ローン凍結',
  detailName20: '担保付ローン拒否',
  detailName21: '担保付ローン',
  detailName22: '担保付ローン返済',
  detailName23: '担保付ローン決済済み',

  usersAgreementsTitle: 'ユーザー同意書',
  usersAgreements: `<p>1. FTZINC <span style="font-family: 宋体;">は、世界的なブロックチェーン資産取引愛好家向けに提供されています。</span> <span style="font-family: 宋体;">この契約には、お客様の権利や利益と重要な関係がある、または関係する可能性がある条項、およびプラットフォームが責任を免除または制限する、または免除または制限する可能性がある条項が記載されていますので、ご注意ください。</span> <span style="font-family: 宋体;">あなたは、このサービスを受け入れるためにこのプラットフォームのユーザーとして登録する前に、この契約のすべての内容を完全に読み、理解し、同意したことを確認します。</span> <span style="font-family: 宋体;">このサービスを使用すると、本契約のすべての条項に従うことに同意したものとみなされます。</span></p><p>2. <span style="font-family: 宋体;">お客様は、本プラットフォームがいつでも本契約の内容を一方的に変更し、お客様に別途通知することなく更新してサービス契約ページに表示する権利を有することに同意します。</span> <span style="font-family: 宋体;">本規約の内容変更の発表後に引き続きサービスを利用する場合、変更後の規約の内容をよく読み、理解し、承諾し、変更後の規約の内容に従ってサービスを利用することを意味します。</span> ; <span style="font-family: 宋体;">改定後の規約内容にご同意いただけない場合は、サービスのご利用を中止してください。</span></p><p>3. <span style="font-family: 宋体;">お客様は、本契約に同意し、このプラットフォームのユーザーとして登録した時点で</span> 18 <span style="font-family: 宋体;">歳に達していることを保証します。</span> <span style="font-family: 宋体;">本契約の内容は、お住まいの国または地域の法律によって除外されません。</span> <span style="font-family: 宋体;">上記の条件を満たさない場合は、直ちに登録を終了するか、サービスの利用を停止してください。</span></p><p>1. <span style="font-family: 宋体;">アカウントの利用制限</span></p><p>1.1 <span style="font-family: 宋体;">本サービスを利用する場合、お客様は、お住まいの国または地域の法令および関連する国際慣例を遵守し、違法な目的（取引商品の取引の禁止または制限を含む）に本サービスを利用したり、いかなる目的にも利用しないものとします。</span> <span style="font-family: 宋体;">違法な方法で本サービスをご利用ください。</span></p><p>1.2 <span style="font-family: 宋体;">お客様は、他者の正当な権利および利益を侵害する行為に本サービスを利用してはなりません。そうでない場合、本プラットフォームは、調査、遅延、解決の拒否、または本サービスの提供を拒否する権利を有し、お客様は、関連するすべての行為を独自に負担する必要があります。</span> <span style="font-family: 宋体;">法的責任、したがってこのプラットフォームまたはこのプラットフォームを引き起こした従業員が負傷した場合、あなたは賠償責任を負うものとします。</span></p><p><span style="font-family: 宋体;">上記のアクションには次のものが含まれますが、これらに限定されません。</span></p><p><span style="font-family: 宋体;">ａ．</span> <span style="font-family: 宋体;">評判、プライバシー、企業秘密など、他人の正当な権利と利益を侵害すること。</span></p><p>b. <span style="font-family: 宋体;">法律で定められた、または同意された守秘義務に違反する行為。</span></p><p>c. <span style="font-family: 宋体;">他人名義でサービスを利用すること。</span></p><p>d. <span style="font-family: 宋体;">マネーロンダリング、テロ資金供与、麻薬取引、またはプラットフォームがサービスを使用すべきではないと判断するその他の状況などの違法取引に関与すること。</span></p><p>e. <span style="font-family: 宋体;">コンピュータウイルスを含む可能性のある行為、またはサービスシステムやデータを侵害する可能性のある行為。</span></p><p>f. <span style="font-family: 宋体;">ご本人もしくは相手方の申告した取引内容と矛盾する取引、または虚偽の取引を行うこと。</span></p><p>g. <span style="font-family: 宋体;">その他、正当な理由により当プラットフォームが不適切と判断する行為。</span></p><p>2. FTZINC<span style="font-family: 宋体;">仲介サービス</span></p><p><span style="font-family: 宋体;">を含む：</span></p><p>2.1 <span style="font-family: 宋体;">エスクロー：お客様は、本サービスが指定する方法を使用して、</span>FTZINC <span style="font-family: 宋体;">アカウント（本プラットフォームがサポートするビットコインおよびその他のデジタル資産を含み、以下同じ）をリチャージし、お客様に代わって本プラットフォームに保管することを委託することができます。</span></p><p>2.2 <span style="font-family: 宋体;">決済：このプラットフォーム上のお客様と他のユーザー間の取引については、プラットフォームは第三者として機能し、デジタル資産（各国の法定通貨を含まない）の取引決済サービスを提供します。</span> <span style="font-family: 宋体;">あなたは、プラットフォーム上での決済後は、本契約で合意しない限り、支払いは取り消すことができないことに同意するものとします。</span></p><p>2.3 <span style="font-family: 宋体;">出金</span>: <span style="font-family: 宋体;">あなたは、このプラットフォームに管理を委託したデジタル資産の金額の支払いをこのプラットフォームに要求することができます。</span> <span style="font-family: 宋体;">プラットフォームにコインの出金指示を送信するときは、プラットフォーム上で設定した有効な検証方法を検証する必要があります。</span> <span style="font-family: 宋体;">プラットフォームは指定された時間内に成功した検証指示を受け取り</span> (<span style="font-family: 宋体;">特にプラットフォームの規制に従います</span>)<span style="font-family: 宋体;">、対応する番号と資産の金額が、指定した有効な配送先住所に送金されます。</span></p><p>2.4 <span style="font-family: 宋体;">クエリ</span>: <span style="font-family: 宋体;">このシステムでは、アカウント名の取引記録をリアルタイムでクエリできます。</span></p><p>2.5 <span style="font-family: 宋体;">金銭専用</span>: <span style="font-family: 宋体;">プラットフォームは、お客様がこのプラットフォームに支払ったデジタル資産シェアを保管し、お客様のアカウントに属し、お客様の指示以外の目的に使用することはありません。</span></p><p>3. <span style="font-family: 宋体;">登録関連</span></p><p><span style="font-family: 宋体;">この</span> Web <span style="font-family: 宋体;">サイトに直接登録し、このプラットフォームから提供されるアカウントを取得する必要があります。</span> <span style="font-family: 宋体;">あなたが同意する：</span></p><p>3.1 <span style="font-family: 宋体;">プラットフォーム要件に従って正確に提供し、アカウント取得後、正確で最新かつ完全な検証情報をタイムリーに更新します。</span> <span style="font-family: 宋体;">あなたが提供した情報が間違っている、最新ではない、または不完全であるとプラットフォームが結論付ける理由があり、プラットフォームが関連情報の提供を要求する場合、あなたが時間内に提供できない場合、当社はあなたの情報を拒否する権利を有します。</span> <span style="font-family: 宋体;">このウェブサイトにアクセスし、アカウントを終了または一時停止します。</span></p><p>3.2 <span style="font-family: 宋体;">このプラットフォームがタイムリーかつ効果的に連絡できるように、提供する電子メール</span> <span style="font-family: 宋体;">アドレスおよびその他の連絡先情報を正確かつタイムリーに更新する必要があります。</span> <span style="font-family: 宋体;">これらの連絡方法を通じて連絡できないことにより、本サービスの利用中に発生した損失または費用の増加、その他の悪影響については、お客様が単独で責任を負うものとします。</span> <span style="font-family: 宋体;">あなたは、提供した連絡先情報の有効性を維持する義務があることを理解し、これに同意します。</span> <span style="font-family: 宋体;">更新する必要がある変更がある場合は、このプラットフォームの要件に従って操作する必要があります。</span></p><p>3.3 <span style="font-family: 宋体;">あなたのアカウントには、他人の身元認証情報、他人の銀行口座などの使用を含むがこれらに限定されない、誤解を招く情報または詐欺的な情報が含まれていてはなりません。</span></p><p>3.4 <span style="font-family: 宋体;">情報（本プラットフォームのアカウントに紐づく携帯電話番号、電子メールアドレス等を含むがこれに限定されない）を適時に更新しなかったため、サービスを提供できない、または提供時にエラーが発生した場合</span> <span style="font-family: 宋体;">、これを取引のキャンセルまたは支払い拒否の理由として使用してはなりません。そこから生じるすべての結果はお客様が負担し、このプラットフォームは一切の責任を負いません。</span></p><p>3.5 <span style="font-family: 宋体;">あなたは自分のアカウントに対して責任を負い、自分のアカウントを使用できるのはあなただけです。</span></p><p>3.6 <span style="font-family: 宋体;">お客様は、公民権または民事行為の能力の全部または一部を失った場合、このプラットフォームが有効な法的文書（有効な裁判所の判決を含みますがこれに限定されません）に従ってお客様のアカウントに関連する資金を処分する権利を有することに同意するものとします。</span> <span style="font-family: 宋体;">有効な遺言書など）の記事。</span></p><p>3.7 <span style="font-family: 宋体;">当社は、いつでもお客様に本人確認プロセスの完了を求めることができ、また、必要と判断した場合には、追加の本人確認書類をこのプラットフォームに提出するようお客様に求める場合もあります。</span> <span style="font-family: 宋体;">本人確認を完了しない場合は、本契約の違反とみなされます。</span></p><p>3.8 <span style="font-family: 宋体;">当社は、お客様のアカウントまたは当社が提供するその他のサービスへのアクセスを閉鎖、一時停止、または制限したり、デジタル資産残高の使用を</span> 180 <span style="font-family: 宋体;">日間</span> (<span style="font-family: 宋体;">裁判所命令またはその他の法的手続きに従っている場合はそれ以上</span>) <span style="font-family: 宋体;">制限したりする場合があります。</span> <span style="font-family: 宋体;">これらの利用規約またはその他の契約。</span> <span style="font-family: 宋体;">お客様のアカウントに関連するリスクを評価する際、当社は独自のリスク評価モデルを使用することもでき、リスクの高いユーザーは本契約に違反したものとみなされます。</span></p><p>3.9 <span style="font-family: 宋体;">本契約の条項に従い、お客様が本契約または以前の時点で他の契約に違反したと当社が判断した場合、当社はお客様のアカウントおよびサービスのデジタル資産残高の使用を閉鎖、一時停止、または制限することもできます。</span> <span style="font-family: 宋体;">その他の手段を使用しています。</span></p><p>4. <span style="font-family: 宋体;">アカウントのセキュリティ</span></p><p><span style="font-family: 宋体;">このアカウントとパスワードを使用したすべての操作および発言については、お客様の責任となります。</span> <span style="font-family: 宋体;">あなたが同意する：</span></p><p>4.1 <span style="font-family: 宋体;">このプラットフォームは、アカウントのログイン名やパスワードなどの指示を通じて、ユーザーの指示を認識します。</span> <span style="font-family: 宋体;">アカウントのログイン名とパスワードは適切に保管してください。パスワードの漏洩によって生じた損失については、お客様が責任を負います。</span> <span style="font-family: 宋体;">あなたは、自分のアカウントのログイン名とパスワードを他人に開示したり、他人のログイン名とパスワードを使用したりしないことを約束します。</span> <span style="font-family: 宋体;">このプラットフォームは、このサービスを使用して、指示を識別するために使用する他の製品または機器を適用することもあります。</span> <span style="font-family: 宋体;">これらの製品または機器は適切に保管するか、管理下に置く必要があります。</span> <span style="font-family: 宋体;">これらの製品または機器の紛失によって生じた損失については、お客様の責任となります。</span></p><p>4.2 <span style="font-family: 宋体;">あなたは、</span>(a) <span style="font-family: 宋体;">他人があなたのアカウントのログイン名とパスワードを不正に使用または盗んだこと、またはその他の不正使用を発見した場合、効果的な方法で直ちにプラットフォームに通知し、関連サービスの一時停止をプラットフォームに要求する必要があることに同意します。</span> (b) <span style="font-family: 宋体;">連続ログイン期間の終了時に、正しい手順で</span> Web <span style="font-family: 宋体;">サイトから離れるようにするため。</span> <span style="font-family: 宋体;">このプラットフォームは、お客様が本条項を遵守しなかったために発生する損失、損害、その他の悪影響については責任を負いませんし、責任を負いません。</span> <span style="font-family: 宋体;">このプラットフォームでは、リクエストに応じて対応するには合理的な期限が必要であることを理解するものとします。</span> <span style="font-family: 宋体;">それ以前は、プラットフォームは実行された命令および</span>/<span style="font-family: 宋体;">またはそれによって生じた損失に対して責任を負いません。</span></p><p>4.3 <span style="font-family: 宋体;">法的規制または司法判決がある場合を除き、本プラットフォームの同意がある場合を除き、お客様のアカウントのログイン名とパスワード、アカウントをいかなる方法でも譲渡、贈与、または継承することはできません（関連する財産権を除く）。</span></p><p>4.4 <span style="font-family: 宋体;">お客様は、運用および取引の安全性の必要に基づいて、本プラットフォームが本サービスの一部の機能の提供を一時的に停止または制限したり、新たな機能を提供したりする場合があることに同意するものとします。</span> <span style="font-family: 宋体;">何らかの機能が削減、増加または変更された場合、お客様が本サービスを引き続き使用している限り、お客様は引き続き本規約または変更された規約に同意したものとみなされます。</span></p><p>4.5 <span style="font-family: 宋体;">このプラットフォームは、実際の取引の背景と、プラットフォーム製品またはサービスの使用目的を知る権利を有します。</span> <span style="font-family: 宋体;">プラットフォームに必要な真実、包括的かつ正確な情報を誠実に提供する必要があります。</span> <span style="font-family: 宋体;">お客様が虚偽の取引情報を提供したと疑う合理的な理由がプラットフォームにある場合、このプラットフォームは、お客様が使用する製品またはサービスの一部またはすべての機能を一時的または永続的に制限する権利を有します。</span></p><p>4.6 <span style="font-family: 宋体;">あなたは、あなたのアカウントとそのデジタル資産の安全のために、本規約、法律および規制、法的文書の規定に従い、行政権限に従った政府の要件、およびそれが影響を与える可能性があるプラットフォーム自身の判断に従っていることに同意するものとします。</span> <span style="font-family: 宋体;">あなたのアカウント</span> <span style="font-family: 宋体;">リスクが発生した場合、プラットフォームはあなたの名前のアカウントのすべてまたは一部を凍結する、つまりこれらのアカウントの一部またはすべてを一時的に閉鎖する権利を有します。</span> <span style="font-family: 宋体;">凍結の逆のプロセスは凍結解除です。つまり、プラットフォームは凍結されたアカウントの凍結を終了します。</span> <span style="font-family: 宋体;">凍結が発生した場合、お客様が凍結解除を申請した場合、プラットフォームは本規定に従い、前述の凍結理由に基づいて、完全な凍結解除を許可するか部分的な凍結解除を許可するかを決定する権利を有します。</span> <span style="font-family: 宋体;">凍結解除の申請が必ずしも許可されるわけではないことを十分に理解し、凍結解除の際には、このプラットフォームの関連要件に協力して本人確認を行い、身分情報、</span>ID <span style="font-family: 宋体;">カード、パスポート、</span> <span style="font-family: 宋体;">その他の有効な身分証明書およびこのプラットフォームで必要とされるその他の情報または文書。</span></p><p>5 アカウント利用ルール</p><p>このサービスを使用する際にお客様の法的権利を効果的に保護するために、お客様は以下の規則を理解し、受け入れることに同意するものとします。</p><p>5.1 このサービスを使用すると、指定された条件を満たすユーザーとの間でデジタル資産の決済の代理人として機能することをこのプラットフォームに承認したことになります。</p><p>5.2 本プラットフォームは、以下の 2 つの方法でお客様からの指示を受け付けます。まず、お客様は、本ウェブサイト上でアカウント名とパスワードを使用してアカウントにログインし、本サービスのあらかじめ設定されたプロセスに従って、取引ステータスや指示を変更または確認します。 次に、電子メール、携帯電話、またはその他のコミュニケーション ツールを介してシステムに送信された情報に、アカウント名または登録時にアカウントに関連付けられたアカウントとして返信します。 上記の 2 つの方法のいずれでプラットフォームに指示を送信するかに関係なく、その指示を撤回したり取り消したりすることはできません。プラットフォームがユーザーに代わってお金の支払いや受け取り、またはその他のアカウント操作を実行するための唯一の指示となります。 ご自身の指示とみなします。 プラットフォームが上記の指示を忠実に実行した結果については、お客様が責任を負う必要があります。 本契約に別段の定めがある場合を除き、お客様が第三者と取引に関する紛争を抱えた場合、お客様は、このプラットフォームが独自の判断を下し、取引の一方または両方の当事者に紛争金額の全部または一部を支払うことを決定することを承認するものとします。</p><p>5.3 本プラットフォームは、取引の進行状況を電子メール（または携帯電話に送信されるSMSや電話など）で通知し、次のステップに進むよう促しますが、本プラットフォームは電子メールの受信または受信を保証するものではありません。 時間内に（または携帯電話に送信されるテキスト メッセージや電話など）、いかなる影響も負わないため、取引プロセス中に表示および取引操作を行うために、時間内にこの Web サイトにログインする必要があります。 このプラットフォームは、お客様が適時に取引ステータスを表示および変更または確認しなかったこと、または関連する申請書の提出を怠ったことによって引き起こされる紛争または損失に対して責任を負いません。</p><p>5.4 本契約に基づくデジタル資産の移転は、対応するネットワークを通じて実現され、お客様は、デジタル資産の移転中に合理的な時間がかかることを理解し、これに同意するものとします。</p><p>5.5 取引リスク</p><p>ａ． このサービスを使用する際、お客様またはお客様の取引指示に誤りがあり（価格、数量、その他の要因を含みますがこれらに限定されません）、取引に損失が生じた場合、その損失についてはお客様が責任を負います。</p><p>b. お客様の過失により生じた損失はお客様の負担となります。 障害には、トランザクション プロンプトに従わない、トランザクション操作を時間内に実行できない、パスワードを忘れたり漏洩したり、他人にパスワードを解読されたり、コンピュータが他人に使用されたりすることが含まれますが、これらに限定されません。</p><p>c. 本サービスを利用する際、ウェブサイトの取引システムやルールの潜在的な未発見の抜け穴により不当な利益を得た場合、当サイトはそれを回収するためにお客様に連絡する権利を有し、お客様は効果的に協力しなければなりません。そうでない場合、当サイトの救済措置には以下が含まれます。 これに限らず、口座取引の制限、口座資金の凍結、訴訟等も行われます。 お客様が効果的に協力しなかったことにより当社に発生した賠償費用もお客様の負担となります。</p><p>5.6. お客様は、このプラットフォームが、利益、商品、データなどの損失を含むがこれらに限定されない、以下の状況のいずれかによって生じた損害に対して責任を負わないことを理解し、これに同意するものとします。</p><p>ａ． このプラットフォームは、お客様が本規約の明示的な規定および精神に違反したとプラットフォームが判断した場合を含むがこれに限定されない、一方的な判断に基づいて、このサービスまたはお客様の名前でのアカウントの一部の提供を一時停止、中断、または終了する権利を有します。 同意し、データを削除します。</p><p>b. 本プラットフォームは、異常な取引、法律や本規約の条項に対する疑いや違反を発見した場合、お客様名義のアカウントの使用（お客様名義のアカウントの使用を含みますがこれに限定されません）を予告なく一時停止または終了する権利を有します。 決済および輸送中の取引には、取引のキャンセルや口座調整などの制限措置が講じられ、本サービスの一部または全部の機能の利用が拒否されます。</p><p>6. サービス料金</p><p>6.1 お客様が本サービスを利用する場合、本プラットフォームは「アカウントサービス料金規定」に従ってサービス料金を請求する権利を有します。 このプラットフォームはサービス料金を策定および調整する権利を有します。 具体的なサービス料金は、お客様がサービスを利用する際に本ウェブサイトに記載されている課金方法の発表、またはお客様とプラットフォームとの間で締結されたその他の書面による合意の対象となります。</p><p>6.2 別段の記載または同意がない限り、お客様は、このプラットフォームが管理、収集、または支払いを委託した金銭から上記のサービス料金を直接差し引く権利を有することに同意するものとします。</p><p>7. プライバシー保護</p><p>この契約に同意するか、このサービスを使用すると、このプラットフォームが次の条件に従って個人情報を使用および開示することに同意したものとみなされます。</p><p>7.1 アカウントのログイン名とパスワード</p><p>アカウントやサービスの登録時に、本人確認のためアカウントのログイン名とパスワードの設定をお願いするほか、パスワードを紛失した場合の本人確認のため携帯電話のSMS認証や実名認証の設定をお願いします。 設定したパスワードを持つアカウントのみを使用できます。 パスワードが漏洩すると、個人識別情報が失われ、不利な法的結果が生じる可能性があります。 何らかの理由でアカウントとパスワードが潜在的または実際に危険にさらされている場合は、直ちにプラットフォームに連絡する必要があります。 プラットフォームがアクションを起こす前は、プラットフォームはこれに対して責任を負いません。</p><p>7.2 登録情報</p><p>登録時には、電話番号やメールアドレスなどの関連情報を提供する必要があります。 的を絞った方法で新しいサービスと機会を提供するために、お客様は、このプラットフォームがお客様の連絡先情報 (携帯電話、電子メールなどを含むがこれらに限定されない) を通じて関連する通知やその他の商用電子情報を送信することを理解し、これに同意するものとします。 。</p><p>7.3 トランザクションの動作</p><p>本プラットフォームは、お客様のサービス利用の安全性を確保し、サービスの品質を継続的に向上させるため、お客様のログインおよび本サービスの利用に関する関連情報を記録し保存しますが、本プラットフォームは、かかる情報を第三者に提供しないことを約束します。 第三者（両当事者が別段の合意をしない限り、または法律や規制で別段の定めがある場合を除く）。</p><p>7.4 お客様は、法律や規制に従ってより安全かつ効果的にサービスを提供するため、またはプラットフォームがお客様の身元を特定する必要がある場合、またはプラットフォームがお客様のアカウントが危険にさらされていると判断した場合、プラットフォームが要求する権利を有することに同意するものとします。 身元情報（IDカード、戸籍簿、パスポート、その他の書類またはその他の書類を含みますが、これらに限定されません）を提出する必要があります。 本契約に別段の定めがある場合を除き、</p><p> </p><p>ａ． 事前に明示的な許可を得てください。</p><p>b. 本契約の要件に従って開示する。</p><p>c. 法令に基づく場合</p><p>d. 政府当局の要件に従います。</p><p>e. このプラットフォームの正当な権利と利益を保護するため。</p><p>7.5 外部リンク</p><p>このウェブサイトには他のウェブサイトへのリンクが含まれていますが、当プラットフォームは他のウェブサイトのプライバシー保護措置について責任を負いません。 このプラットフォームは、必要に応じてビジネス パートナーや共有ブランド ウェブサイトを追加することがあります。</p><p>7.6 セキュリティ</p><p>このプラットフォームは、このプラットフォームが保持する情報の紛失、悪用、および改ざんを防ぐために、既存のテクノロジーに従って対応するセキュリティ対策を提供するだけです。 これらのセキュリティ対策には、他のサーバーへのデータのバックアップやユーザー パスワードの暗号化が含まれます。 これらのセキュリティ対策にもかかわらず、このプラットフォームはこの情報の絶対的なセキュリティを保証するものではありません。</p><p>8. システムの中断または障害</p><p>以下の事由によりシステムが正常に動作しなくなり、各種サービスが利用できなくなった場合、本プラットフォームは、以下の損害について一切の責任を負いません。</p><p>8.1 プラットフォームの Web サイトで発表されたシステムのシャットダウンおよびメンテナンス期間中。 8.2 電気通信機器がデータの送信に失敗する。</p><p>8.3 台風、地震、津波、洪水、停電、戦争、テロ攻撃などの不可抗力要因により、システム障害により本プラットフォームのシステムが実行できなくなる場合があります。</p><p>8.4 ハッカー攻撃、コンピュータウイルスの侵入または攻撃、電気通信部門の技術的調整または機能不全、ウェブサイトのアップグレード、政府の規制による一時的なシャットダウン、およびネットワークの通常の運用に影響を与えるその他の理由によるサービスの中断または遅延。</p><p>8.5 ユーザーが不正に操作したり、プラットフォームによって許可または承認されていない方法でプラットフォーム サービスを使用したりする。</p><p>8.6 ユーザーのコンピュータのソフトウェアおよびハードウェア、通信回線、および電源回線が故障している。</p><p>9. 責任の範囲および責任の制限</p><p>このプラットフォームは、本契約で指定された責任の範囲についてのみ責任を負います。</p><p>9.1 本プラットフォーム上のユーザー情報はユーザー自らが提供するものであり、本プラットフォームは情報の正確性、有効性、完全性を保証するものではありません。</p><p>9.2 プラットフォームは、お客様とお客様の（取引）相手方に同時にプラットフォーム サービスを提供する場合があります。 お客様は、プラットフォーム上に存在する可能性のある行為から、実際のまたは潜在的な利益相反を明示的に免除することに同意し、プラットフォームがプラットフォームを提供していると主張することはできないものとします。 サービスには法的欠陥があります。</p><p>9.3 このサービスの使用を通じてデータをダウンロードまたは取得する場合は、ご自身の責任で検討してください。 データのダウンロードによって引き起こされるコンピュータ システムへの損傷またはデータの損失は、すべてお客様の責任となります。</p><p>9.4 このプラットフォームおよびそのスタッフから、またはこのサービスを通じて得たアドバイスや情報は、書面か口頭かにかかわらず、このサービスに対するプラットフォームの保証を構成するものではありません。</p><p>10. 完全な合意</p><p>本規約は、本規約と本ウェブサイトに掲載する「サービス料金規定」その他の規定から構成されます。 関連する用語を引用したり相互に参照したりすることができます。 異なる理解があった場合には、本契約の条項が優先するものとします。 この契約を理解し、同意する場合は、この契約のすべての要素を理解し、同意することになります。 このサービスを使用すると、あなたとこのプラットフォームは、この契約のすべての要素に拘束されることになります。 本契約の内容の一部が管轄司法当局によって違法とみなされた場合でも、他の内容の有効性には影響しません。</p><p>11. 商標および知的財産権の保護</p><p>11.1 作品、写真、ファイル、情報、素材、ウェブサイトの構造、ウェブサイトの画面構成、ウェブデザインを含むがこれらに限定されない、このウェブサイト上のすべてのコンテンツは、商標権、特許を含むがこれらに限定されない、法律に従ってプラットフォームによって所有されています。 権利、著作権、営業秘密等</p><p>11.2 このプラットフォームの書面による同意がない限り、誰も許可なくこのウェブサイトの手順またはコンテンツを使用、変更、コピー、公に配布、変更、配布、発行、または公に公開することはできません。</p><p>11.3 知的財産権を尊重することはあなたの義務です。 違反があった場合は損害賠償の責任を負います。</p><p>12. 法律の適用と裁判管轄本契約の有効性、解釈、変更、履行および紛争解決はすべて、プラットフォームが存在する場所の法律に適用されます。 関連する法規定がない場合は、一般的な国際商慣行および/または業界慣行を参照してください。 本契約から生じる紛争は、プラットフォームが所在する場所の法律に従って処理されるものとし、プラットフォームが所在する場所の司法当局が第一審の管轄権となります。</p>`,

  privacyPolicyTitle: 'プライバシーポリシー',
  privacyPolicy: `<p><span style="font-family: 宋体;">このプライバシーに関する声明は、</span>FTZINC <span style="font-family: 宋体;">のすべての関連サービスに適用されます。</span> FTZINC <span style="font-family: 宋体;">は、</span>FTZINC <span style="font-family: 宋体;">プラットフォーム</span> <span style="font-family: 宋体;">サービスを使用するすべてのユーザーの個人プライバシーを尊重し、保護します。</span> <span style="font-family: 宋体;">より正確でパーソナライズされたサービスを提供するために、</span>FTZINC <span style="font-family: 宋体;">はこのプライバシー</span> <span style="font-family: 宋体;">ポリシーの規定に従ってお客様の個人情報を使用および開示しますが、</span>FTZINC <span style="font-family: 宋体;">はこの情報を高度な勤勉さと慎重さをもって扱います。</span> <span style="font-family: 宋体;">このプライバシーポリシーに別段の定めがある場合を除き、</span>FTZINC <span style="font-family: 宋体;">はお客様の事前の許可なしにこの情報を第三者に開示または提供することはありません。</span> FTZINC <span style="font-family: 宋体;">は、このプライバシー</span> <span style="font-family: 宋体;">ポリシーを随時更新します。</span> FTZINC <span style="font-family: 宋体;">サービス契約に同意すると、このプライバシー</span> <span style="font-family: 宋体;">ポリシーの内容全体に同意したものとみなされます。</span> <span style="font-family: 宋体;">このプライバシー</span> <span style="font-family: 宋体;">ポリシーはサービス契約の不可欠な部分です。</span></p><p>1. <span style="font-family: 宋体;">利用範囲</span></p><p><span style="font-family: 宋体;">当社プラットフォームにログイン可能なアカウントを登録または有効化する場合、当社関連会社が提供する他のプラットフォーム上で提供されるお客様の個人登録情報（法令に基づき開示が必要な商号等の関連事業登録情報を除く）</span> <span style="font-family: 宋体;">、および自然人のオペレーターに関する情報</span>; FTZINC <span style="font-family: 宋体;">または</span> FTZINC <span style="font-family: 宋体;">の</span> Web <span style="font-family: 宋体;">ページを使用すると、</span>FTZINC <span style="font-family: 宋体;">は、</span>IP <span style="font-family: 宋体;">アドレス、ブラウザの種類、使用言語、アクセス日時、ソフトウェア</span> <span style="font-family: 宋体;">データを含むがこれらに限定されない、ブラウザおよびコンピュータ上の情報も記録します。</span> <span style="font-family: 宋体;">必要なハードウェアの機能情報や</span> Web <span style="font-family: 宋体;">ページの記録など、</span>FTZINC <span style="font-family: 宋体;">を通じてビジネス</span> <span style="font-family: 宋体;">パートナーから取得したユーザーの個人データ。</span></p><p>2. <span style="font-family: 宋体;">情報の利用</span></p><p><span style="font-family: 宋体;">当社は、お客様が事前に許可を得た場合、または第三者と当社</span> (<span style="font-family: 宋体;">当社の関連会社を含む</span>) <span style="font-family: 宋体;">が個別または共同でお客様にサービスを提供する場合を除き、お客様の個人情報を無関係の第三者に提供、販売、賃貸、共有、または取引することはありません。</span> <span style="font-family: 宋体;">サービス終了後は、これまでの全ての資料へのアクセスを禁止させていただきます。</span></p><p><span style="font-family: 宋体;">以前はアクセスできていました。</span> <span style="font-family: 宋体;">また、第三者がいかなる手段によってもお客様の個人情報を収集、編集、販売、配布することを許可しません。</span> <span style="font-family: 宋体;">当社プラットフォームのユーザーが上記の行為を行っていることが判明した場合、当社はそのユーザーとのサービス契約を直ちに終了する権利を有します。</span></p><p>3. <span style="font-family: 宋体;">情報開示</span></p><p><span style="font-family: 宋体;">当社は、以下の場合には、お客様ご本人の希望または法的規制に従い、お客様の個人情報の全部または一部を開示します。</span> <span style="font-family: 宋体;">お客様の事前の同意を得た場合、第三者に開示する場合。</span> <span style="font-family: 宋体;">あなたが適格な知的財産申立人であり、苦情を提出した場合、被申立人の要請に応じて、両当事者が起こり得る権利紛争に対処できるように、被申立人に開示します。</span> <span style="font-family: 宋体;">法律の関連規定、または行政機関または司法機関の要求に従って、第三者または行政機関または司法機関に開示する。</span> <span style="font-family: 宋体;">関連する法律、規制、または当社のサービス契約または関連規則に違反し、第三者に開示する必要がある場合。</span> <span style="font-family: 宋体;">リクエストした製品やサービスを提供するには、個人情報を第三者と共有する必要があります。</span> <span style="font-family: 宋体;">当社のプラットフォーム上で作成された取引において、取引当事者のいずれかが取引義務を履行または部分的に履行し、情報開示を要求した場合、当社は、取引を容易にするために取引相手の連絡先情報などの必要な情報をユーザーに提供することを決定する権利を有します。</span> <span style="font-family: 宋体;">取引の完了または紛争の解決。</span> <span style="font-family: 宋体;">当社は、法令やウェブサイトポリシーに従い、当社が適切と判断した情報を開示します。</span></p><p>4. <span style="font-family: 宋体;">情報の保管と交換</span></p><p><span style="font-family: 宋体;">当社がお客様に関して収集した情報およびデータは、当社および（または）その関連会社のサーバーに保存されます。</span> <span style="font-family: 宋体;">この情報およびデータは、お客様の国、地域、または海外に送信され、そこで当社が情報およびデータを収集し、海外でアクセスされ、保管および表示される場合があります。</span></p><p>5. Cookie<span style="font-family: 宋体;">の使用について</span></p><p><span style="font-family: 宋体;">お客様が</span> Cookie <span style="font-family: 宋体;">の受け入れを拒否しない場合、お客様がログインしたり、</span>Cookie <span style="font-family: 宋体;">に依存する当社のプラットフォーム</span> <span style="font-family: 宋体;">サービスや機能を使用できるように、当社はお客様のコンピュータに</span> Cookie <span style="font-family: 宋体;">を設定またはアクセスします。</span> <span style="font-family: 宋体;">当社は、プロモーション</span> <span style="font-family: 宋体;">サービスなど、より思慮深くパーソナライズされたサービスを提供するために</span> Cookie <span style="font-family: 宋体;">を使用します。</span> <span style="font-family: 宋体;">あなたには、</span>Cookie <span style="font-family: 宋体;">を受け入れるか拒否するかを選択する権利があります。</span> <span style="font-family: 宋体;">ブラウザの設定を変更することで、</span>Cookie <span style="font-family: 宋体;">の受け入れを拒否できます。</span> <span style="font-family: 宋体;">ただし、</span>Cookie <span style="font-family: 宋体;">の受け入れを拒否することを選択した場合、</span>Cookie <span style="font-family: 宋体;">に依存する当社のプラットフォーム</span> <span style="font-family: 宋体;">サービスや機能にログインしたり、使用したりできなくなる場合があります。</span> <span style="font-family: 宋体;">このポリシーは、</span>FTZINC <span style="font-family: 宋体;">が設定した</span> Cookie <span style="font-family: 宋体;">を通じて取得された関連情報に適用されます。</span></p><p>6. <span style="font-family: 宋体;">情報セキュリティ</span></p><p><span style="font-family: 宋体;">アカウントにはセキュリティ保護機能が付いていますので、アカウントとパスワードの情報は正しく保管してください。</span> <span style="font-family: 宋体;">当社は、他のサーバーへのバックアップやユーザー</span> <span style="font-family: 宋体;">パスワードの暗号化などのセキュリティ対策を講じて、お客様の情報が紛失、悪用、改ざんされないようにします。</span> <span style="font-family: 宋体;">上記のセキュリティ対策は行っておりますが、情報ネットワークにおいて「完璧なセキュリティ対策」は存在しませんのでご了承ください。</span> <span style="font-family: 宋体;">オンライン取引に当社のプラットフォーム</span> <span style="font-family: 宋体;">サービスを使用する場合、必然的に連絡先情報や住所などの個人情報を取引相手または潜在的な取引相手に開示する必要があります。</span> <span style="font-family: 宋体;">ご自身の個人情報は適切に保護し、必要な場合にのみ他人に提供してください。</span> <span style="font-family: 宋体;">お客様の個人情報、特にアカウントとパスワードが漏洩したことに気付いた場合は、対応措置を講じますので、直ちに当社のカスタマーサービスにご連絡ください。</span> <span style="font-family: 宋体;">未成年者に対する特別な注意事項</span> <span style="font-family: 宋体;">あなたが公民権および民事行為の完全な能力を備えた自然人ではない場合、当社のプラットフォーム</span> <span style="font-family: 宋体;">サービスを使用する権利はありません。そのため、個人情報を当社に提供しないでください。</span></p><p><span style="font-family: 宋体;">お客様のアカウントサービスが終了した後、または</span> FTZINC <span style="font-family: 宋体;">におけるアカウントの権限が永久に凍結</span> (<span style="font-family: 宋体;">キャンセル</span>) <span style="font-family: 宋体;">された後、</span>FTZINC <span style="font-family: 宋体;">はお客様のアカウント内の情報を保持または開示する義務を負わず、お客様が読んでいない情報を転送する義務も負わないものとします。</span> <span style="font-family: 宋体;">第三者または送信されたメッセージ。</span></p><p><span style="font-family: 宋体;">お客様は、</span>FTZINC <span style="font-family: 宋体;">との契約関係が終了した後も、</span>FTZINC <span style="font-family: 宋体;">が以下の権利を引き続き享受することに同意します</span>: FTZINC <span style="font-family: 宋体;">サービスの使用中にお客様のユーザー情報およびすべての取引情報を引き続き保管します。</span> FTZINC <span style="font-family: 宋体;">サービスの使用中に法律に違反したり、本契約および</span>/<span style="font-family: 宋体;">または規則に違反したりした場合でも、</span>FTZINC <span style="font-family: 宋体;">は本契約に従ってお客様の権利を主張することができます。</span></p><p>FTZINC<span style="font-family: 宋体;">がお客様への</span>FTZINC<span style="font-family: 宋体;">サービスの提供を一時停止または終了した後、サービスの一時停止または終了前のお客様の取引は以下の原則に従って処理されるものとし、お客様は単独で処理し、紛争、損失または追加費用を全額負担するものとします。</span> <span style="font-family: 宋体;">以下の処理により発生します。</span> <span style="font-family: 宋体;">また、その結果として</span> FTZINC <span style="font-family: 宋体;">が損失やコストを負担しないことも保証する必要があります。</span> <span style="font-family: 宋体;">サービスの一時停止または終了前に</span> FTZINC <span style="font-family: 宋体;">にアップロードしたビットコインやその他の仮想通貨などの仮想通貨がまだ取引されていない場合</span> FTZINC<span style="font-family: 宋体;">は、すでに取引を行っている権利を有しており、他の会員が売買契約に至ったが、実際に契約が履行されていない場合、</span>FTZINC<span style="font-family: 宋体;">は売買契約およびビットコイン等の仮想通貨に関する情報を削除する権利を有します。</span> <span style="font-family: 宋体;">仮想通貨。</span> <span style="font-family: 宋体;">サービスが一時停止または終了される前に他の会員と売買契約に達しており、それが部分的に履行されている場合、</span>FTZINC<span style="font-family: 宋体;">は取引を削除することはできませんが、</span>FTZINC<span style="font-family: 宋体;">はサービスを一時停止または終了する際に関連する状況を取引相手に通知する権利を有します。</span> <span style="font-family: 宋体;">。</span></p><p>7. <span style="font-family: 宋体;">プライバシーポリシー</span>FTZINC<span style="font-family: 宋体;">は、</span>FTZINC<span style="font-family: 宋体;">サイト上でプライバシーポリシーを随時発表し、改訂します。</span> <span style="font-family: 宋体;">プライバシー</span> <span style="font-family: 宋体;">ポリシーは、本契約の有効な部分を構成します。</span></p>`,

  legalStatementTitle: '法的声明',
  legalStatement: `<p><strong>第1条：</strong></p><p><span style="font-family: 宋体;">このウェブサイトは、米国の関連法規に違反することなく、可能な限り世界中のデジタル資産愛好家および投資家に、専門的で安全かつ信頼できるデジタル資産取引および資産管理サービスを提供することを目的としています。</span> <span style="font-family: 宋体;">ただし、お客様が拠点を置く国または地域が、デジタル資産取引が明示的に禁止されている管轄区域、または制裁対象国のリストに含まれている管轄区域である場合、お客様は、本ウェブサイトが提供するサービスの利用を控えるものとします。</span></p><p><strong>第2条：</strong></p><p><span style="font-family: 宋体;">このプラットフォームは、そのユーザーのために、準拠した安全で信頼性の高いデジタル資産取引環境を構築することに取り組んでいます。</span> <span style="font-family: 宋体;">ユーザーは、本ウェブサイトを利用してマネーロンダリング、密輸、商業贈収賄、市場の悪意のある操作、その他の違法な取引活動や違法行為に従事することを禁じられています。</span> <span style="font-family: 宋体;">この観点から、当社は可能な限り厳格なマネーロンダリングおよびテロ対策プログラムを策定し、ユーザーの正当な権利と利益を最大化し、プラットフォームの良好な評判を維持するために効果的なセキュリティリスク管理措置を講じます。</span></p><p><strong>第3条：</strong></p><p><span style="font-family: 宋体;">管轄当局が、関連する捜査令状に基づいて、プラットフォームに対し、特定のユーザーの調査に協力すること、またはユーザーのアカウントに対してそのアカウントの閉鎖または凍結、またはそのアカウントからの資産の移管などの措置を講じることを要求する場合、これは、</span> <span style="font-family: 宋体;">ウェブサイトは、かかる令状の有効性と信頼性を検証した後、管轄当局の要件に従って調査を支援するために、ユーザーの関連データを当局に提供するか、対応する業務を実行するものとします。</span> <span style="font-family: 宋体;">プラットフォームは、ユーザーのプライバシーの開示、またはかかる調査によるユーザーのアカウント操作不能によってユーザーが被る可能性のある直接的または間接的な損失については一切の責任を負いません。</span></p><p><strong>第4条：</strong></p><p><span style="font-family: 宋体;">本ウェブサイトが提供するサービスを利用するユーザーは、取引を行う前に、以下の点に留意するものとします。</span> <span style="font-family: 宋体;">デジタル資産は政府や中央銀行によって支援されていないこと、デジタル資産の価格は大幅に変動する可能性があること、および保有または</span> <span style="font-family: 宋体;">デジタル資産の使用には重大なリスクが伴います。</span> <span style="font-family: 宋体;">これを考慮して、取引の決定を下す前に、お客様は合理的かつ慎重な方法で自身の財務状況を評価し、提案された取引がお客様にとって適切であるかどうかを判断する必要があります。</span></p><p><strong>第5条：</strong></p><p><span style="font-family: 宋体;">本ウェブサイトのユーザーが本声明の規定に違反し、それによりセーシェル共和国の関連法のいずれかに違反した場合、本ウェブサイトは、本契約に基づくサービスのプロバイダーとして、プラットフォームのルールとサービスを改善する義務を負います。</span> <span style="font-family: 宋体;">ただし、このウェブサイトには、米国の関連法に違反する動機はなく、また、かかる法律に違反した事実もありません。</span> <span style="font-family: 宋体;">したがって、このウェブサイトは、かかるユーザーの行為に対して連帯責任を負わないものとします。</span></p><p><strong>第6条：</strong></p><p><span style="font-family: 宋体;">何らかの方法で本</span> Web <span style="font-family: 宋体;">サイトにログインする、または本</span> Web <span style="font-family: 宋体;">サイトのサービスを直接的または間接的に使用するユーザーは、この声明の内容に同意し、この声明に拘束されることに自発的に同意するものとみなされます。</span></p><p><strong>第7条：</strong></p><p><span style="font-family: 宋体;">この声明に記載されていない事項については、米国の関連法規を参照してください。</span> <span style="font-family: 宋体;">この声明が米国の関連法および規制のいずれかに矛盾する場合は、後者が優先されます。</span></p>`,

  launderingPolicyTitle: 'マネーロンダリング防止ポリシー',
  launderingPolicy: `<p><span style="font-family: 宋体;">第</span>1<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">策定の目的と根拠</span> <span style="font-family: 宋体;">マネーロンダリング活動がデジタル資産取引の発展に深刻な悪影響を及ぼし、汚職を助長</span>・<span style="font-family: 宋体;">助長し、社会的雰囲気を損ない、ユーザーの正当な権利と利益を損ない、社会の基盤を損なうという事実に鑑み、</span> <span style="font-family: 宋体;">デジタル資産取引プラットフォームの安定的な運営。</span> <span style="font-family: 宋体;">マネーロンダリングおよびテロ資金供与活動を防止するため、コインブラウンは、「コインブラウンマネーロンダリング防止規則」、「顧客同意書」および「大口取引」に従って、マネーロンダリング防止およびテロ資金供与防止法の関連規定を遵守します。</span> <span style="font-family: 宋体;">」。</span> <span style="font-family: 宋体;">このガイドラインは、管理措置等の社内規程に基づいて策定されます。</span></p><p><span style="font-family: 宋体;">第</span>2<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">適用範囲</span> <span style="font-family: 宋体;">これらのガイドラインは、</span>FTZINC <span style="font-family: 宋体;">取引プラットフォームでの取引に参加するすべてのユーザーに適用されます。</span> <span style="font-family: 宋体;">ユーザーは、ユーザーが居住する国または地域のマネーロンダリングおよびテロ資金供与対策に関する法令を遵守し、ユーザーの地域の法律が定める範囲内で本ガイドの規定を実施するものとします。</span> <span style="font-family: 宋体;">ユーザーが居住する国または地域でより厳しい要件がある場合は、その規制に従ってください。</span></p><p><span style="font-family: 宋体;">第</span>3<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">マネーロンダリング対策とテロ資金供与対策とは、犯罪者が麻薬犯罪、裏社会の性質の組織犯罪、テロ犯罪、密輸犯罪、汚職および贈収賄犯罪を隠蔽および隠蔽するために、</span>FTZINC<span style="font-family: 宋体;">プラットフォームを介して取引を行うことを防止する目的を指します。</span> <span style="font-family: 宋体;">金融詐欺犯罪および妨害行為</span> <span style="font-family: 宋体;">財務管理者は、犯罪およびその他の不法収入、マネーロンダリング活動の源泉および性質について、関連法および</span>FTZINC<span style="font-family: 宋体;">のマネーロンダリング防止規制に従って、関連措置を講じるよう命令します。</span></p><p><span style="font-family: 宋体;">第</span>4<span style="font-family: 宋体;">条：</span></p><p>FTZINC<span style="font-family: 宋体;">のマネーロンダリング対策関連規定</span> FTZINC<span style="font-family: 宋体;">のマネーロンダリング対策（テロ資金供与対策を含む。以下同じ）に関する規定には、「利用規約」のマネーロンダリング対策部分である「</span>FTZINC<span style="font-family: 宋体;">マネーロンダリング対策規定」が含まれます。</span> <span style="font-family: 宋体;">、および「大規模トランザクション管理対策」については、このガイドを参照してください。</span> <span style="font-family: 宋体;">このガイドに記載されている内容が他のルールと矛盾する場合は、このガイドが優先されます。</span></p><p><span style="font-family: 宋体;">第</span>5<span style="font-family: 宋体;">条：</span></p><p>FTZINC <span style="font-family: 宋体;">のマネーロンダリング対策の基本原則は、次の原則に従って顧客リスク監視作業を実行することです。</span></p><p><span style="font-family: 宋体;">包括性の原則。</span> FTZINC<span style="font-family: 宋体;">プラットフォームは、顧客がマネーロンダリングに関与する可能性のあるさまざまなリスク要因を包括的に考慮し、合理的な方法を採用してすべての顧客のリスクを監視します。</span></p><p><span style="font-family: 宋体;">慎重さの原則。</span> FTZINC <span style="font-family: 宋体;">プラットフォームは、顧客の完全な理解に基づいて顧客を特定し、顧客のリスクを慎重に監視する能力を向上させます。</span></p><p><span style="font-family: 宋体;">持続可能性の原則。</span> FTZINC<span style="font-family: 宋体;">プラットフォームは今後も顧客のリスクに注意を払い、実情に応じて適切に対応してまいります。</span></p><p><span style="font-family: 宋体;">機密保持の原則。</span> FTZINC<span style="font-family: 宋体;">プラットフォームが保有する顧客の身元情報、取引情報、リスクレベル情報は極秘であり、法的規制や規制要件に従わない限り、いかなる部門や個人にも提供されることはありません。</span></p><p><span style="font-family: 宋体;">階層管理の原則。</span> FTZINC <span style="font-family: 宋体;">プラットフォームは、顧客のリスク</span> <span style="font-family: 宋体;">レベルに応じて保存されている基本的な顧客情報を定期的に確認します。</span> <span style="font-family: 宋体;">リスク</span> <span style="font-family: 宋体;">レベルが高い顧客の審査は、リスク</span> <span style="font-family: 宋体;">レベルが低い顧客の審査よりも厳しくする必要があります。</span></p><p><span style="font-family: 宋体;">第</span>6<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">個人ユーザー文書の提出</span> FTZINC <span style="font-family: 宋体;">の個人ユーザーは、</span>FTZINC <span style="font-family: 宋体;">のマネーロンダリング防止規制に従って、以下の情報および資料を提出する必要があります。</span></p><p><span style="font-family: 宋体;">個人名</span></p><p>ID<span style="font-family: 宋体;">カード、パスポート、運転免許証などの有効な書類。</span></p><p>FTZINC <span style="font-family: 宋体;">の要求に応じて提供する必要があるその他の情報または文書。</span></p><p><span style="font-family: 宋体;">第</span>7<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">機関ユーザー文書の提出</span> FTZINC <span style="font-family: 宋体;">機関ユーザーは、</span>FTZINC <span style="font-family: 宋体;">マネーロンダリング防止規制に従って、以下の情報および資料を提出する必要があります。</span></p><p><span style="font-family: 宋体;">会社名</span>;</p><p><span style="font-family: 宋体;">会社の登記上の住所。</span></p><p><span style="font-family: 宋体;">会社の法定代理人。</span></p><p><span style="font-family: 宋体;">会社の法定代表者の住所。</span></p><p><span style="font-family: 宋体;">ビジネスライセンス</span>;</p><p><span style="font-family: 宋体;">会社の法定代理人の</span>ID<span style="font-family: 宋体;">カードまたはパスポートのコピー</span>;</p><p>FTZINC <span style="font-family: 宋体;">の要求に応じて提供する必要があるその他の情報または文書。</span></p><p><span style="font-family: 宋体;">第</span>8<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">ユーザードキュメントのレビュー。</span> FTZINC<span style="font-family: 宋体;">プラットフォームは、</span>FTZINC<span style="font-family: 宋体;">マネーロンダリング防止規制の顧客識別システムに従って、顧客が提出した関連情報を検証し、記録します。</span> <span style="font-family: 宋体;">プラットフォームが顧客から提出された情報に関して疑問がある場合、プラットフォームは関連する管轄機関または部門に確認する権利を有します。</span></p><p><span style="font-family: 宋体;">第</span>9<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">低リスクのユーザーの監視</span> FTZINC <span style="font-family: 宋体;">プラットフォームは、</span>FTZINC <span style="font-family: 宋体;">のマネーロンダリング防止規制の特定の要件に従って、低リスクのユーザーを検出します。</span> FTZINC<span style="font-family: 宋体;">プラットフォームは、低リスクユーザーのレベルを調整する権利を留保します。</span></p><p><span style="font-family: 宋体;">第</span>10<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">高リスクのユーザーの監視</span> FTZINC <span style="font-family: 宋体;">プラットフォームは、</span>6 <span style="font-family: 宋体;">か月ごとに高リスクの顧客を調査して、顧客の身元に関する基本情報を更新し、資金源、資金の用途、経済状況、または運営状況を把握します。</span></p><p><span style="font-family: 宋体;">第</span>11<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">ユーザーファイルの保存</span> FTZINC<span style="font-family: 宋体;">プラットフォームは、顧客の身元データと取引情報を一定期間保存するために、法律に従って必要な措置を講じます。</span> <span style="font-family: 宋体;">国際的に認められた規則を参照すると、ユーザーの身元情報は取引関係の終了後、また顧客の取引情報は取引終了後から少なくとも</span> 5 <span style="font-family: 宋体;">年間保管される必要があります。</span></p><p><span style="font-family: 宋体;">第</span>12<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">ユーザーの注意</span> FTZINC <span style="font-family: 宋体;">ユーザーは、次の事項に注意してください。</span> <span style="font-family: 宋体;">ユーザー自身のアカウントを他人に貸与することは禁止されています。</span></p><p><span style="font-family: 宋体;">ユーザーの身分証明書を貸与したり貸与したりすることは禁止されています。</span></p><p><span style="font-family: 宋体;">ユーザー自身の口座、キャッシュカード、通帳、パスワード、その他の重要な個人財産情報を貸与、貸与、または開示することは禁止されています。</span></p><p><span style="font-family: 宋体;">ユーザーは、顧客識別のために</span> FTZINC <span style="font-family: 宋体;">プラットフォームに積極的に協力する必要があります。</span></p><p>FTZINC<span style="font-family: 宋体;">プラットフォームで取引する場合、支払い活動には安全で信頼できる第三者金融機関を選択して使用してください。</span></p><p><span style="font-family: 宋体;">第</span>13<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">不審な行為の報告</span> FTZINC <span style="font-family: 宋体;">プラットフォームのユーザーが、プラットフォーム取引中にアカウントがマネーロンダリングまたはテロ資金供与活動に関与している可能性があることを発見した場合、ユーザーは</span> FTZINC <span style="font-family: 宋体;">プラットフォームに報告することができます。</span></p><p><span style="font-family: 宋体;">第</span>14<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">このガイドのガイドラインの解釈は、</span>FTZINC <span style="font-family: 宋体;">プラットフォームによって解釈されます。</span></p><p><span style="font-family: 宋体;">第</span>15<span style="font-family: 宋体;">条：</span></p><p><span style="font-family: 宋体;">有効期間</span> <span style="font-family: 宋体;">ガイドラインは発行日から施行されます。</span></p>`,
  
  tradeMin100: '最低取引金額: 100 USDT',
  cancelled: 'キャンセル',

  phone: '電話(オプション)',
  phone1: '電話',

  toTrade: '今すぐ取引する',

  openRecord: 'オープンレコード',
  closeRecord: "記録を閉じる",

  closeOrder: '注文を閉じる',


  swiperTitle2: '暗号通貨を購入、販売、取引、保持、獲得するためのオールインワン暗号プラットフォーム。',
  swiperSub2: '私たちは何百万人もの世界中のユーザーをデジタル資産への道に導いてきました。',

  homeremind31: '暗号通貨を購入する',
  homeremind32: 'あなたが支払う',
  homeremind33: 'あなたは得します',
  homeremind34: '価格は再計算されます',
  homeremind35: '利用規約',
  homeremind36: '今すぐ購入',
  homeremind37: 'FTZINC は誰にとってもワンステップのプラットフォームです',
  homeremind38: 'クライアント',
  homeremind39: 'サポートされている国',
  homeremind40: '四半期の取引高',

  homeremind41: 'どうやって始めるのか',
  homeremind42: 'アカウントを作成する',
  homeremind43: 'FTZINC にサインインして、新しいプロファイルを登録します。',
  homeremind44: '身元を確認する',
  homeremind45: '検証プロセスは 5 分以内に完了します。',
  homeremind46: 'まずアカウントを作成してください',
  homeremind47: '暗号通貨の購入と入金',
  homeremind48: 'FTZINC アカウントに資金を追加して、暗号通貨サービスにアクセスします。',
  homeremind49: 'まず身元を確認してください',
  homeremind50: '旅を始めましょう',


  homeremind51: 'FTZINC エコシステム内の暗号通貨の機会を探索してください。',
  homeremind52: 'まずは仮想通貨を購入して入金しましょう',
  homeremind53: '暗号ポートフォリオを構築する',
  homeremind54: '仮想通貨を購入する',
  homeremind55: 'FTZINC を選択する理由',
  homeremind56: 'シンプルさ',
  homeremind57: 'FTZINC では、モバイル アプリケーションを使用して暗号通貨を簡単に購入できます。',
  homeremind58: '教育',
  homeremind59: 'どこから始めればよいかわからない? 私たちの学習センターにアクセスして、暗号通貨のすべてについて学びましょう。',

  homeremind60: 'サービス',
  homeremind61: 'サポート センターですぐに答えが見つかります。 または、24時間365日電子メールでお問い合わせください。',
  homeremind62: 'FTZINC を始めましょう',
  homeremind63: '言語',

  signin: 'サインイン',

  withdrawfee: '出金手数料',


  ieointro1: `創設チーム`,
  ieointro2: `エンジェルファンド`,
  ieointro3: `エコシステム`,
  ieointro4: `プレセールフェーズ`,
  ieointro5: `マイニング`,


  ieointro10: `創業チーム`,
  ieointro11: `エンジェルファンド`,
  ieointro12: `エコシステム`,
  ieointro13: `プレセール割り当て`,
  ieointro14: `マイニング報酬`,




  personalInfo: '個人情報',
  modifyPassword: 'パスワードの変更',


  swiperTitle3: '次世代を見つける',
  swiperTitle4: 'FTZINC での暗号通貨取引',
  swiperTitle5: `暗号通貨取引所 {'|'} 信用取引 {'|'} 暗号デリバティブ`,

  homeremind64: '今すぐサインアップ',
  homeremind65: '対象国',
  homeremind66: '世界的な投資家',
  homeremind67: '暗号',
  homeremind68: '24時間取引高',

  homeremind69: 'Scan QR Code to Download App',//No need
  homeremind70: '電子メールアドレス',

  homeremind71: '新しい暗号のプレセール',
  homeremind72: 'View all 700+ coins', //No need

  homeremind73: 'Coming Soon',//No need
  homeremind74: '購読する',

  homeremind75: 'ホットリスト',
  homeremind76: 'ゲイナーリスト',
  homeremind77: '敗者リスト',

  homeremind78: '世界をリードする仮想通貨取引所を今すぐ試してみましょう',
  homeremind79: `安全性 {'|'} 無料 {'|'} 速い {'|'} 分散化`,
  homeremind80: 'View more benefits',//No need
  homeremind81: 'たった 1 つのステップでメールアドレスで登録して今すぐ取引できます',


  homeremind82: 'FTZINC の製品とサービスを詳しく見る',
  homeremind83: '現物取引',
  homeremind84: '利益を最大化するための強力なツールの包括的なセットを使用して仮想通貨を取引します。',
  homeremind85: '仮想通貨を購入する',
  homeremind86: '業界をリードする人気のプラットフォームで仮想通貨を迅速かつ簡単に購入できます。',
  homeremind87: '暗号デリバティブ',
  homeremind88: '当社は仮想通貨先物の取引に最適な仮想通貨取引所です。',
  homeremind89: 'FTZINC Earn',//No need
  homeremind90: 'Invest and earn steady income with the help of a professional asset manager.',//No need
  homeremind91: 'Trading Bot',//No need
  homeremind92: 'Earn passive income round-the-clock without having to constantly monitor markets.',//No need
  homeremind93: '信用取引',
  homeremind94: '信用取引で資産を活用しましょう。',
  homeremind95: 'Leveraged Tokens',//No need
  homeremind96: 'Amplify your investment returns by simply buying and selling leveraged tokens.',//No need
  homeremind97: 'Halo Wallet',//No need
  homeremind98: 'A self-custody social wallet that allows you to easily discover, invest, and earn.',//No need

  homeremind99: '安全で信頼できる暗号通貨取引所',
  homeremind100: '安全な資産ストレージ',
  homeremind101: '業界をリードする当社の暗号化およびストレージ システムにより、お客様の資産は常に安全に保たれます。',
  homeremind102: '強力なアカウントセキュリティ',
  homeremind103: '当社は最高のセキュリティ基準を遵守し、お客様のアカウントを安全に保つために最も厳格なセキュリティ対策を実施しています。',
  homeremind104: '信頼できるプラットフォーム',
  homeremind105: '当社では、あらゆるサイバー攻撃を迅速に検出して対応できるよう、セキュア・バイ・デザインの基盤を整備しています。',
  homeremind106: 'PoR — 資産の透明性',
  homeremind107: 'PoR（Proof of Reserves）は、ブロックチェーン上の資産の保管を証明するために広く使用されている方法であり、FTZINCが帳簿上のすべてのユーザー資産をカバーする資金を持っていることを確認します。',

  homeremind108: 'Learn More',//No need
  homeremind109: 'いつでもどこでも取引',
  homeremind110: 'FTZINC アプリとウェブサイトを使用すると、仮想通貨を簡単に取引できます。',
  
  
  homeremind111: '年中無休のカスタマーサービス',
  homeremind112: 'あなたの質問に答えます。 ご質問がございましたら、いつでも FTZINC カスタマーサポートにお問い合わせください。',
  homeremind113: 'FTZINC Help Center',//No need
  homeremind114: '私たちのコミュニティに参加する',
  homeremind115: 'FTZINC グローバル コミュニティには 100 か国以上からの数百万人のユーザーがおり、20 以上の言語をサポートしています。',
  homeremind116: '英語コミュニティ',
  homeremind117: 'View all 20+ languages',//No need
  homeremind118: 'FTZINC バイ・ユア・サイド',
  homeremind119: '今すぐ暗号化の旅を始めましょう!',
  
  appDownload: 'アプリのダウンロード',
  androidDownload: 'アンドロイドのダウンロード',
  iosDownload: 'iOSのダウンロード',


  funding: '資金調達',



  withdrawTip4: `出金申請ごとに`,
  withdrawTip5: `の手数料が差し引かれ、出金額に対して`, 
  withdrawTip6: `のみが差し引かれます。`, 

  assetsManagement: '資産管理',
  myAssets: '資産',


  homeremind194: `30秒で始めましょう！`,

  homeremind195: `アカウントを作成する`,
  homeremind196: `メールアドレスを入力し、受信トレイで 5 桁の確認コードを確認してください。確認ページでコードを入力するだけで、サインアップが完了します。`,
  homeremind197: `入金する`,
  homeremind198: `FTZINC の Web またはアプリで簡単にアカウントに資金を入金できます。`,
  homeremind199: `取引を始める`,
  homeremind200: `お気に入りのスポットペアまたは先物契約で旅を始めましょう!`,


  homeremind139: 'QRコードをスキャン',
  homeremind140: 'Android / iOS用のFTZINCアプリをダウンロード',


  homeremind120: '新コイン先行販売',
  homeremind121: `Encryption Open AIは、世界有数のデジタル通貨取引所であるMEXC Global、Huobi、Bybitと独占上場契約を締結しており、これはEOトークンが市場で広く認知され受け入れられていることを示しています。EOトークンが世界中のトップ取引所に上場され、流通し続けるにつれて、その人気と影響力はさらに拡大し、Encryption Open AIの発展にさらに強い推進力を提供します。`,
  homeremind122: 'Encryption Open AI',
  homeremind123: '発行価格',
  homeremind124: '開始日',
  homeremind125: '有効期限',
  homeremind126: '購読する',
  homeremind127: '購読者',
  homeremind128: '購読済み',
  homeremind129: '終了日',
  homeremind130: '日々',


  ieoIntro: 'トークンの紹介',
  homeSentence1: `24時間年中無休のサービス`,
  homeSentence2: `フルタイムオペレーション`,
  homeSentence3: `あらゆる取引ニーズを満たす`,
  homeSentence4: `いつでもどこでも取引`,


  check: 'チェック',


  commodities: '商品',




  forgotPassword: `パスワードをお忘れですか？`,
  registerText: `アカウントをお持ちではありませんか？`,
  registerText1: `こちらにサインアップ`,

  loginText: `アカウントにサインイン`,
  loginText1: `アカウントをお持ちですか?`,
  loginText2: `ここからサインイン`,

  loginPolicy: `登録することにより、利用規約およびプライバシーポリシーに記載されている個人データの取り扱いに同意します。`,
  registerPolicy: `サインインすることにより、利用規約およびプライバシーポリシーに記載されている個人データの取り扱いに同意します。`,

  loginLayoutText: `世界中で150万人以上のユーザーから信頼されています。いつでもご利用いただけます。`,

  homeSwiperTitle: `最高の暗号通貨取引プラットフォームでスポット、マージン、先物、OTCを取引しましょう`,
  homeSwiperText: `プロのトレーディングを、すべての人に。`,

  startTrading: '取引を開始する',
  exploreMarkets: '市場を探索する',

  downloadOn: `ダウンロード`,
  getItOn: `乗って`,

  homeCoinListSentence: `初心者からプロのトレーダーまで`,
  homeCoinListSentence1: `購入、販売、管理`,
  homeCoinListSentence2: `100以上の暗号資産`,
  homeCoinListSentence3: `すべての暗号資産を探索する`,

  homeWhyChooseSentence: `なぜFTZINCなのか？`,
  homeWhyChooseSentence1: `世界中で150万人以上のユーザーが選ぶ暗号通貨取引所`,
  //homeWhyChooseSentence2: `more than 1.5 million users globally`,
  homeWhyChooseSentence3: `効率的な市場`,
  homeWhyChooseSentence4: `さまざまな注文タイプと取引ツールを備えた FTZINC の流動的なスポット、スポット マージン、永久先物市場で 100 種類以上の暗号資産を取引します。`,
  homeWhyChooseSentence5: `柔軟な利回り商品`,
  homeWhyChooseSentence6: `弊社の使いやすい流動性ステーキング ソリューションで収益を生み出し、オンライン ステーキングの複雑な部分を弊社が処理します。`,
  homeWhyChooseSentence7: `世界クラスのAPI`,
  homeWhyChooseSentence8: `当社の機関投資家向け API は、リアルタイムおよび過去の市場データ、共有アカウント、非常に競争力のあるレート制限を提供します。`,
  homeWhyChooseSentence9: `簡単な通貨換算`,
  homeWhyChooseSentence10: `当社のシンプルな売買スワップ端末、銀行振込、または OTC プラットフォームを通じて、さまざまな通貨を暗号通貨に簡単に変換できます。`,
  homeWhyChooseSentence11: `カスタマーサポート`,
  homeWhyChooseSentence12: `当社は、お客様のニーズに合わせてサービスをカスタマイズし、迅速かつ役立つカスタマー サポートと、企業パートナー向けのプライベート サポート チャネルを提供しています。`,
  homeWhyChooseSentence13: `迅速なオンボーディング`,
  homeWhyChooseSentence14: `KYC および AML に完全に準拠し、データ プライバシーを最大限に尊重する当社の自動オンボーディング プロセスは、数分で完了します。`,

  homeQuicklyStartSentence: `すぐに取引を開始`,
  homeQuicklyStartSentence1: `数分で開始できます`,
  //homeQuicklyStartSentence2: `in minutes`,
  homeQuicklyStartSentence3: `アカウントを開設する`,
  homeQuicklyStartSentence4: `数分でアカウントを作成して確認しましょう`,
  homeQuicklyStartSentence5: `アカウントに資金を入金する`,
  homeQuicklyStartSentence6: `銀行振込で法定通貨を入金するか、暗号通貨を直接入金してアカウントに資金を入金します`,
  homeQuicklyStartSentence7: `取引を開始する`,
  homeQuicklyStartSentence8: `スポット、スポットマージン、先物で100種類以上の暗号資産を取引したり、強力なAPIと統合して取引を最大限に活用したりできます。`,

  homeGetStartSentence: `プロトレーディング、`,
  homeGetStartSentence1: `、すべての人のために。`,
  homeGetStartSentence2: `始めましょう`,

  homeOurInvestorsSentence: `投資家の皆様`,



  favorites: 'お気に入り',
  original: 'オリジナル',



  indices: `指数`,
  indicesNotAllowOpen: `市場閉鎖中はポジションを開くことはできません`,
  indicesNotAllowClose: `市場閉鎖中はポジションを閉じることはできません`,
  indicesNotAllowSet: `市場閉鎖中は注文を変更することはできません。`,




  tokenIntroduction: `トークンのご紹介`,
  newWhitepaper: `ホワイトペーパー`,



  kbfIntro1: `シンガポールを拠点とするQuantum Asset Management Pte Ltdが主導するKentucky Butterfly Farm（KBF）は、資産取引のための先駆的なAMM（自動マーケットメーカー）ベースのパブリックブロックチェーンです。グローバルな会計マーケットメーカーメカニズム（AMM）、ブロックチェーンゲーム、ソーシャルインフラストラクチャを基盤として構築されたKBFは、商用アプリケーション向けのスーパーコンピューティングシステムとして機能し、AMM、GameFi、SocialFiといった多様なサービスの迅速な展開を可能にします。`,

kbfIntro2: `KBFパブリックブロックチェーンネットワーク技術は、数々の利点を備えています。中でも特筆すべきは高いパフォーマンスであり、KBFブロックチェーンはより多くのトランザクションを処理し、トランザクション確認時間を短縮できます。デジタル金融分野では、スピードと効率性がサービス品質を評価する重要な指標となります。KBFブロックチェーンは、技術アーキテクチャの継続的な最適化を通じてトランザクション処理能力を向上させ、ユーザーに迅速かつ効率的な金融サービス体験を提供しています。`,

kbfIntro3: `さらに、KBFパブリックブロックチェーンは卓越したスケーラビリティを備えています。デジタル金融市場の急速な成長に伴い、ユーザーベースとアプリケーションの需要は拡大し続けています。こうした高まる需要に応えるため、KBFブロックチェーンは当初から将来のネットワーク拡張性を念頭に置いて設計されました。AMM（自動マーケットメイキング）とゼロ知識証明技術を活用することで、ユーザー数や取引量の急増にも容易に対応し、安定したネットワーク運用と持続可能な発展を保証します。`,
  code: `認証コード`,
  codeInput: `認証コードを入力してください`,

  homepage: {
    hero: {
      title: `Web3の次の時代`,
      titleWeb3: `へ。`,
      highlight: `みんなのために`,
      everyone: `設計されています。`,
      description: `FTZINCは、取引・収益化・ゲーム・開発をひとつにまとめたWeb3エコシステム。シンプルで安全、そしてとても楽しい体験を提供します。`,
      launchApp: `アプリを起動`,
      exploreEcosystem: `エコシステムを見る`,
      statsAriaLabel: `FTZINCの概要`,
      stats: {
        happyUsers: `利用ユーザー`,
        tvlLocked: `ロックされたTVL`,
        transactions: `取引数`,
        countries: `対応国`,
      },
      imageAlt: `FTZINCアプリ、暗号資産トークン、親しみやすいロボットマスコット`,
    },
    market: {
      title: `暗号資産を探す`,
      description: `リアルタイム価格を確認し、値動きのある資産を見つけて、次のチャンスを探しましょう。`,
      view: `マーケット表示`,
      tabs: {
        popular: `人気`,
        gainers: `上昇率トップ`,
        losers: `下落率トップ`,
      },
      viewAll: `すべてのマーケットを見る`,
      itemAria: `{name}、{price} USDT、24時間で{change}`,
      noPriceChanges: `表示できる価格変動はまだありません。別の表示をお試しください。`,
      dataPending: `価格に接続するとマーケットデータが表示されます。`,
    },
    features: {
      sectionTitle: `FTZINCエコシステムを見る`,
      trade: {
        title: `スムーズに取引`,
        description: `低い手数料と最適なレートで、複数チェーンのトークンを交換できます。`,
      },
      earn: {
        title: `報酬を獲得`,
        description: `FTZINCでステーキングやファーミングを行い、パッシブ収入を得ましょう。`,
      },
      play: {
        title: `探索して遊ぶ`,
        description: `楽しいWeb3ゲームとクエスト。遊んで、稼いで、レベルアップ！`,
      },
      build: {
        title: `構築して展開`,
        description: `FTZINCで未来をつくるためのツールとインフラ。`,
      },
      secure: {
        title: `安全でシンプル`,
        description: `すべての人のために設計された体験と、最高水準のセキュリティ。`,
      },
    },
    ecosystem: {
      title: `FTZINCエコシステム`,
      allProducts: `すべてのプロダクト`,
      products: {
        wallet: {
          title: `FTZINCウォレット`,
          description: `Web3への入り口。`,
        },
        swap: {
          title: `FTZINC Swap`,
          description: `クロスチェーン交換をもっと簡単に。`,
        },
        earn: {
          title: `FTZINC Earn`,
          description: `暗号資産の収益を最大化。`,
        },
        launchpad: {
          title: `FTZINC Launchpad`,
          description: `次の注目プロジェクトを見つけて、立ち上げましょう。`,
        },
        commodities: {
          title: `FTZINC 商品`,
          description: `エネルギー、金属など世界のコモディティを探索。`,
        },
        indices: {
          title: `FTZINC 指数`,
          description: `主要な市場指数を追跡し、自信を持って取引しましょう。`,
        },
      },
    },
    pocket: {
      title: `FTZINCのパワーを`,
      titleLine2: `ポケットに`,
      description: `いつでもどこでもWeb3を管理し、取引し、探索できます。`,
      imageAlt: `FTZINCモバイルウォレット、交換機能、クエスト体験`,
    },
    learn: {
      title: `学び、成長し、先を行こう。`,
      viewAll: `すべての記事を見る`,
      articles: {
        web3: {
          category: `基礎`,
          title: `Web3とは？`,
          description: `インターネットの未来を知る初心者向けガイド。`,
        },
        stake: {
          category: `ガイド`,
          title: `NEXをステーキングする方法`,
          description: `FTZINCで収益化を始めるためのステップガイド。`,
        },
        security: {
          category: `セキュリティ`,
          title: `Web3で安全に過ごす`,
          description: `資産を守るために必要なポイント。`,
        },
        chain: {
          category: `エコシステム`,
          title: `FTZINC Chainを解説`,
          description: `スピード、拡張性、未来のために構築。`,
        },
      },
    },
    voices: {
      title: `コミュニティの声`,
      chris: `FTZINCならWeb3がシンプルで楽しくなります。UIは分かりやすく、チームも最高です。`,
      diana: `多くのプラットフォームを試しましたが、FTZINCは本物です。速く、安全で、簡単です。`,
      wolf: `必要なものがすべてひとつの場所に揃っています。とても気に入っています！`,
      mia: `FTZINCのゲームは夢中になります。楽しみながら稼げるのが最高です。`,
      dan: `FTZINC Chainでの開発はとてもスムーズでした。ツールもサポートも素晴らしいです！`,
    },
    newsletter: {
      title: `最新情報をいち早く。`,
      description: `FTZINCのプロダクト情報、Web3の知見、先行アクセスを受け取りましょう。`,
      emailLabel: `メールアドレス`,
      emailPlaceholder: `メールアドレスを入力`,
      createAccount: `アカウントを作成`,
    },
  },
}
